import React, { useCallback, useEffect, useState, useRef, Component } from 'react';
import { Check, ChevronLeft, ChevronRight, X, Lock } from 'lucide-react';
import { MissionNavbar } from '../components/MissionNavbar';
const WHATSAPP_URL = 'https://wa.me/77010346443?text=%D1%85%D0%BE%D1%87%D1%83%20%D0%B4%D0%B5%D0%BC%D0%BE%20Meelo';
const CHAOS = [92, 70, 45, 20, 0];
const ENERGY = [18, 40, 60, 78, 92];
const MEELO_MSGS = ['Привет. Я Meelo. Давайте спасём ваш детский сад от операционного хаоса.', 'Отлично! Хаос отступает. Идём дальше.', 'Порядок в документах — это спокойствие.', 'Кухня под контролем. Остался последний шаг!', 'Поздравляю! Ваш сад работает как часы.'];
const BUILDINGS = [{
  id: 1,
  name: 'Дворец утерянного контроля',
  icon: '🏰',
  color: '#7C4DFF',
  gradient: 'linear-gradient(135deg, #EDE7F6 0%, #D1C4E9 100%)',
  modalGradient: 'linear-gradient(135deg, #7C4DFF 0%, #651FFF 100%)',
  quote: 'Здесь прячется главный источник тревоги — потерянный контроль.',
  chaos: [{
    label: '📊 Excel',
    r: -8,
    t: 12,
    l: 8
  }, {
    label: '❓ Оплаты',
    r: 5,
    t: 28,
    l: 45
  }, {
    label: '📋 Сверки',
    r: -3,
    t: 14,
    l: 68
  }]
}, {
  id: 2,
  name: 'Методологическая крепость',
  icon: '📚',
  color: '#E91E63',
  gradient: 'linear-gradient(135deg, #FCE4EC 0%, #F8BBD9 100%)',
  modalGradient: 'linear-gradient(135deg, #FF4081 0%, #E91E63 100%)',
  quote: 'Методика должна давать уверенность, а не стресс.',
  chaos: [{
    label: '📄 Планы',
    r: 7,
    t: 10,
    l: 5
  }, {
    label: '📝 Конспекты',
    r: -5,
    t: 30,
    l: 40
  }, {
    label: '🗂 Отчёты',
    r: 4,
    t: 12,
    l: 68
  }]
}, {
  id: 3,
  name: 'Замок питания и снабжения',
  icon: '🍎',
  color: '#43A047',
  gradient: 'linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%)',
  modalGradient: 'linear-gradient(135deg, #43A047 0%, #2E7D32 100%)',
  quote: 'Самая скрытая утечка денег — здесь.',
  chaos: [{
    label: '🥕 Закуп',
    r: -6,
    t: 10,
    l: 6
  }, {
    label: '📝 Журнал',
    r: 5,
    t: 28,
    l: 42
  }, {
    label: '⚠️ Ошибка',
    r: -3,
    t: 12,
    l: 66
  }]
}, {
  id: 4,
  name: 'Родительский бастион',
  icon: '👨‍👩‍👧',
  color: '#2979FF',
  gradient: 'linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%)',
  modalGradient: 'linear-gradient(135deg, #2979FF 0%, #1565C0 100%)',
  quote: 'Когда родители спокойны — спокойны и вы.',
  chaos: [{
    label: '«Где меню?»',
    r: -5,
    t: 12,
    l: 4
  }, {
    label: '«Был ли ребёнок?»',
    r: 4,
    t: 30,
    l: 38
  }, {
    label: '«Что на обед?»',
    r: -2,
    t: 14,
    l: 66
  }]
}];
// ── Sound ──────────────────────────────────────────────────────────────────
function playChime() {
  try {
    const AudioCtx = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioCtx) return;
    const ctx = new AudioCtx();
    [523, 659, 784].forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = 'sine';
      osc.frequency.value = freq;
      const t = ctx.currentTime + i * 0.14;
      gain.gain.setValueAtTime(0, t);
      gain.gain.linearRampToValueAtTime(0.12, t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.001, t + 0.35);
      osc.start(t);
      osc.stop(t + 0.35);
    });
  } catch (_) {}
}
// ── Confetti ───────────────────────────────────────────────────────────────
const CONFETTI_COLORS = ['#7C4DFF', '#B388FF', '#EDE7F6', '#a78bfa', '#c4b5fd', '#ddd6fe'];
function Confetti({
  active
}: {
  active: boolean;
}) {
  if (!active) return null;
  return <div style={{
    position: 'fixed',
    inset: 0,
    pointerEvents: 'none',
    zIndex: 300,
    overflow: 'hidden'
  }} data-id="element-246">
      {Array.from({
      length: 30
    }).map((_, i) => <div key={i} style={{
      position: 'absolute',
      top: '-10px',
      left: `${i / 30 * 100 + i % 3 * 1.5}%`,
      width: i % 3 === 0 ? 8 : 6,
      height: i % 3 === 0 ? 8 : 6,
      borderRadius: i % 2 === 0 ? '50%' : '2px',
      background: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
      animation: `confetti-fall ${1.2 + i % 5 * 0.2}s ${i % 7 * 0.1}s ease-in forwards`,
      opacity: 0.9
    }} data-id="element-247" />)}
    </div>;
}
// ── Progress Pill ──────────────────────────────────────────────────────────
function ProgressPill({
  progress
}: {
  progress: number;
}) {
  return <div style={{
    position: 'fixed',
    top: 76,
    left: 0,
    right: 0,
    zIndex: 45,
    pointerEvents: 'none'
  }} className="flex justify-center px-4" data-id="element-248">
      <div className="bg-white/90 backdrop-blur-md border border-gray-100 rounded-full shadow-sm px-4 py-1.5 flex items-center gap-3" data-id="element-249">
        <span className="text-xs text-gray-500 font-medium whitespace-nowrap" data-id="element-250">
          🌿 Путь к порядку:
        </span>
        <div className="w-24 h-1.5 bg-gray-100 rounded-full overflow-hidden" data-id="element-251">
          <div className="h-full rounded-full bg-[#7C4DFF]" style={{
          width: `${progress}%`,
          transition: 'width 700ms cubic-bezier(0.4,0,0.2,1)'
        }} data-id="element-252" />
        </div>
        <span className="text-xs font-bold font-mono text-[#7C4DFF] w-8" data-id="element-253">
          {progress}%
        </span>
      </div>
    </div>;
}
// ── Typing Text Component ──────────────────────────────────────────────────
function TypingText({
  lines,
  speed = 28
}: {
  lines: string[];
  speed?: number;
}) {
  const fullText = lines.join('\n');
  const [displayed, setDisplayed] = useState('');
  const [done, setDone] = useState(false);
  useEffect(() => {
    setDisplayed('');
    setDone(false);
    let i = 0;
    const iv = setInterval(() => {
      i++;
      setDisplayed(fullText.slice(0, i));
      if (i >= fullText.length) {
        clearInterval(iv);
        setDone(true);
      }
    }, speed);
    return () => clearInterval(iv);
  }, [fullText, speed]);
  return <span style={{
    whiteSpace: 'pre-line'
  }} data-id="element-254">
      {displayed}
      {!done && <span className="typing-cursor" data-id="element-255">|</span>}
    </span>;
}
// ── Mission 1 — Interactive Adventure ─────────────────────────────────────
const M1_CHAOS_ITEMS = [{
  text: 'Просроченные оплаты',
  anim: 'chaos-float-1',
  top: '10%',
  left: '3%'
}, {
  text: 'Ручные сверки',
  anim: 'chaos-float-2',
  top: '6%',
  right: '3%'
}, {
  text: 'Кто сегодня не пришёл?',
  anim: 'chaos-float-3',
  top: '52%',
  left: '2%'
}, {
  text: 'Таблицы в разных версиях',
  anim: 'chaos-float-4',
  top: '48%',
  right: '2%'
}];
const M1_HIGHLIGHTS = [{
  icon: '💳',
  text: 'Кто уже оплатил'
}, {
  icon: '⏳',
  text: 'От кого ещё ждём оплату'
}, {
  icon: '👥',
  text: 'Кто пришёл / не пришёл'
}, {
  icon: '📊',
  text: 'Финансы и закупки в одном месте'
}];
const M1_MEELO: (string[] | null)[] = [['Привет. Я Meelo.', 'Я вижу, как вы устали.', 'Этот дворец раньше управлялся чётко…'], ['Но сейчас контроль утерян.'], ['Контроль держится на одном человеке.', 'И если он устал — рушится всё.'], ['Смотрите.', 'Вся важная информация — за секунду и всегда под рукой.'], null, null, null, null];
// Soft cloud blobs for the adventure scene
const SCENE_CLOUDS = [{
  w: 96,
  h: 56,
  top: '6%',
  left: '4%',
  anim: 'cloud-float-a',
  delay: '0s',
  opacity: 0.32
}, {
  w: 72,
  h: 44,
  top: '12%',
  right: '6%',
  anim: 'cloud-float-b',
  delay: '0.8s',
  opacity: 0.26
}, {
  w: 112,
  h: 60,
  top: '38%',
  left: '55%',
  anim: 'cloud-float-c',
  delay: '1.6s',
  opacity: 0.2
}, {
  w: 58,
  h: 36,
  top: '58%',
  left: '12%',
  anim: 'cloud-float-a',
  delay: '2.2s',
  opacity: 0.18
}];
function Mission1({
  onComplete
}: {
  onComplete: () => void;
}) {
  const [step, setStep] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const advance = () => setStep(s => Math.min(s + 1, 7));
  const isIntro = step < 3; // adventure intro scene
  const showChaos = step >= 1;
  const showDashboard = step >= 3;
  const highlightCount = Math.max(0, step - 3);
  const showFinal = step >= 7;
  const currentMeelo = M1_MEELO[step];
  return <div data-id="element-256">
      {/* ── SCENE ── */}
      <div className="relative rounded-3xl overflow-hidden mb-4 transition-all duration-700" style={{
      background: isIntro ? 'linear-gradient(180deg, #8F7BFF 0%, #C6B8FF 100%)' : 'linear-gradient(160deg, #F0F7FF 0%, #F5EEFF 100%)',
      minHeight: isIntro ? 260 : 'auto'
    }} data-id="element-257">
        {/* ── INTRO SCENE LAYERS ── */}
        {isIntro && <>
            {/* Central radial glow */}
            <div className="absolute inset-0 pointer-events-none" style={{
          background: 'radial-gradient(ellipse 60% 50% at 50% 30%, rgba(255,255,255,0.28) 0%, transparent 65%)'
        }} data-id="element-258" />

            {/* Floating cloud shapes */}
            {SCENE_CLOUDS.map((c, i) => <div key={i} className="absolute rounded-full pointer-events-none" style={{
          width: c.w,
          height: c.h,
          top: c.top,
          left: (c as any).left,
          right: (c as any).right,
          background: 'rgba(255,255,255,0.55)',
          filter: 'blur(18px)',
          opacity: c.opacity,
          animation: `${c.anim} ${7 + i * 1.5}s ease-in-out infinite`,
          animationDelay: c.delay
        }} data-id="element-259" />)}

            {/* Sparkle stars */}
            <div className="absolute top-[18%] left-[28%] text-white/40 text-xs pointer-events-none" style={{
          animation: 'chaos-float-2 4s ease-in-out infinite'
        }} data-id="element-260">
              ✦
            </div>
            <div className="absolute top-[30%] right-[22%] text-white/30 text-[10px] pointer-events-none" style={{
          animation: 'chaos-float-3 5s ease-in-out infinite',
          animationDelay: '1s'
        }} data-id="element-261">
              ✦
            </div>
            <div className="absolute top-[48%] left-[42%] text-white/25 text-[8px] pointer-events-none" style={{
          animation: 'chaos-float-1 6s ease-in-out infinite',
          animationDelay: '2s'
        }} data-id="element-262">
              ✦
            </div>
          </>}

        {/* Chaos items — styled for light violet background */}
        {showChaos && isIntro && M1_CHAOS_ITEMS.map((item, i) => <div key={i} className="absolute text-[11px] font-semibold px-2.5 py-1.5 rounded-xl" style={{
        top: item.top,
        left: (item as any).left,
        right: (item as any).right,
        background: 'rgba(255,255,255,0.78)',
        border: '1px solid rgba(220,38,38,0.30)',
        color: '#DC2626',
        backdropFilter: 'blur(6px)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        animation: `${item.anim} ${2.6 + i * 0.35}s ease-in-out infinite`,
        animationDelay: `${i * 0.45}s`,
        maxWidth: '48%',
        lineHeight: 1.35
      }} data-id="element-263">
              ❗ {item.text}
            </div>)}

        {/* Dashboard mockup */}
        {showDashboard && <div className="relative cursor-zoom-in" onClick={() => setLightboxOpen(true)} style={{
        animation: 'fadeInUp 500ms ease forwards'
      }} data-id="element-264">
            <img src="https://cdn.magicpatterns.com/uploads/7Tan4tCoZC26N1PHqU6F5U/панель_для_руководителя.png" alt="Дашборд Meelo" className="w-full h-auto block" data-id="element-265" />
            <div className="absolute inset-0 pointer-events-none" style={{
          background: 'linear-gradient(135deg, rgba(124,77,255,0.07) 0%, transparent 55%)',
          animation: 'dashboard-glow 3s ease-in-out infinite'
        }} data-id="element-266" />
            <div className="absolute bottom-2 right-2 flex items-center gap-1 bg-black/50 text-white text-[10px] font-medium px-2 py-1 rounded-lg backdrop-blur-sm" data-id="element-267">
              <span data-id="element-268">🔍</span> Нажми для просмотра
            </div>
          </div>}

        {/* ── MEELO SPEECH BUBBLE — intro scene ── */}
        {currentMeelo && isIntro && <div key={`bubble-${step}`} className="absolute bottom-4 left-4 right-4 flex items-end gap-3" style={{
        animation: 'fadeInUp 350ms ease forwards'
      }} data-id="element-269">
            {/* Meelo avatar — larger */}
            <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 shadow-xl" style={{
          background: 'rgba(255,255,255,0.95)',
          border: '2.5px solid rgba(255,255,255,0.9)',
          animation: 'meelo-bounce 2.2s ease-in-out infinite',
          boxShadow: '0 4px 20px rgba(100,50,200,0.25)'
        }} data-id="element-270">
              <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-1" data-id="element-271" />
            </div>

            {/* Large cartoon speech card */}
            <div className="flex-1 rounded-3xl rounded-bl-lg px-4 py-3.5" style={{
          background: 'rgba(255,255,255,0.88)',
          backdropFilter: 'blur(16px)',
          border: '1.5px solid rgba(255,255,255,0.7)',
          boxShadow: '0 8px 32px rgba(100,50,200,0.18), 0 2px 8px rgba(0,0,0,0.06)'
        }} data-id="element-272">
              <p className="text-sm font-semibold text-[#3D1A8A] leading-relaxed" data-id="element-273">
                <TypingText key={step} lines={currentMeelo} speed={26} data-id="element-274" />
              </p>
            </div>
          </div>}

        {/* "Нажмите, чтобы продолжить →" hint */}
        {isIntro && step < 2 && <p className="absolute top-3 right-3 text-[11px] text-white/55 font-medium pointer-events-none" style={{
        animation: 'chaos-float-3 3s ease-in-out infinite'
      }} data-id="element-275">
            Нажмите, чтобы продолжить →
          </p>}
      </div>

      {/* Meelo bubble — outside scene (solution stages 3+) */}
      {currentMeelo && !isIntro && <div className="flex items-start gap-2.5 mb-4" key={`meelo-${step}`} style={{
      animation: 'fadeInUp 400ms ease forwards'
    }} data-id="element-276">
          <div className="w-9 h-9 rounded-full bg-[#EDE7F6] border border-[#7C4DFF]/30 overflow-hidden flex-shrink-0 mt-0.5" style={{
        animation: 'meelo-bounce 2.4s ease-in-out infinite'
      }} data-id="element-277">
            <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-0.5" data-id="element-278" />
          </div>
          <div className="bg-[#F5F3FF] border border-[#DDD6FE] rounded-2xl rounded-tl-sm px-3 py-2.5 flex-1" data-id="element-279">
            {currentMeelo.map((line, i) => <p key={i} className="text-sm text-[#5B21B6] font-medium leading-snug" data-id="element-280">
                {line}
              </p>)}
          </div>
        </div>}

      {/* Highlight items (steps 3→7) */}
      {showDashboard && <div className="flex flex-col gap-2 mb-4" data-id="element-281">
          {M1_HIGHLIGHTS.map((item, i) => <div key={i} className="flex items-center gap-3 px-3 py-2.5 rounded-xl" style={{
        opacity: highlightCount > i ? 1 : 0,
        transform: highlightCount > i ? 'translateY(0)' : 'translateY(8px)',
        transition: 'opacity 400ms ease, transform 400ms ease',
        background: highlightCount > i ? '#F5F3FF' : 'transparent',
        border: `1.5px solid ${highlightCount > i ? '#DDD6FE' : 'transparent'}`,
        pointerEvents: 'none'
      }} data-id="element-282">
              <span className="text-base leading-none" data-id="element-283">{item.icon}</span>
              <p className="text-sm font-medium text-[#1A1A2E] flex-1" data-id="element-284">
                {item.text}
              </p>
              {highlightCount > i && <Check size={14} color="#7C4DFF" strokeWidth={2.5} className="flex-shrink-0" data-id="element-285" />}
            </div>)}
        </div>}

      {/* Final message */}
      {showFinal && <div className="rounded-xl px-4 py-3 mb-5 border" style={{
      background: 'linear-gradient(135deg, #F3EEFF 0%, #EEF4FF 100%)',
      borderColor: '#DDD6FE',
      animation: 'fadeInUp 450ms ease forwards'
    }} data-id="element-286">
          <p className="text-sm text-[#5B21B6] font-semibold leading-relaxed" data-id="element-287">
            Контроль возвращён.
          </p>
          <p className="text-xs text-[#7C4DFF] font-medium leading-relaxed mt-0.5" data-id="element-288">
            Вы снова управляете ситуацией — а не она вами.
          </p>
        </div>}

      {/* ── ACTION BUTTONS ── */}
      {step === 2 ? <button onClick={advance} className="w-full py-3 rounded-xl text-sm font-semibold bg-[#7C4DFF] text-white hover:bg-[#651FFF] transition-all active:scale-95" style={{
      boxShadow: '0 0 24px rgba(124,77,255,0.45)'
    }} data-id="element-289">
          🔍 Вернуть контроль
        </button> : showFinal ? <button onClick={onComplete} className="w-full py-3 rounded-xl text-sm font-semibold bg-[#7C4DFF] text-white hover:bg-[#651FFF] transition-all shadow-lg active:scale-95" data-id="element-290">
          Завершить миссию →
        </button> : step < 2 ? <button onClick={advance} className="w-full py-2.5 rounded-xl text-sm font-semibold transition-all active:scale-95" style={{
      background: 'rgba(255,255,255,0.82)',
      color: '#5B21B6',
      border: '1.5px solid rgba(255,255,255,0.6)',
      boxShadow: '0 2px 12px rgba(100,50,200,0.12)'
    }} data-id="element-291">
          Продолжить ›
        </button> : step >= 3 && step < 7 ? <button onClick={advance} className="w-full py-2.5 rounded-xl text-sm font-medium text-[#7C4DFF] border border-[#DDD6FE] bg-[#F5F3FF] hover:bg-[#EDE7F6] transition-all active:scale-95" data-id="element-292">
          Показать следующее ›
        </button> : null}

      {/* ── LIGHTBOX ── */}
      {lightboxOpen && <div className="fixed inset-0 z-[200] flex items-center justify-center p-4" style={{
      background: 'rgba(0,0,0,0.88)',
      backdropFilter: 'blur(6px)',
      animation: 'fadeInUp 200ms ease forwards'
    }} onClick={() => setLightboxOpen(false)} data-id="element-293">
          <div className="relative w-full max-w-3xl" onClick={e => e.stopPropagation()} data-id="element-294">
            <button onClick={() => setLightboxOpen(false)} className="absolute -top-10 right-0 flex items-center gap-1.5 text-white/60 hover:text-white text-sm font-medium transition-colors" data-id="element-295">
              <X size={16} data-id="element-296" /> Закрыть
            </button>
            <img src="https://cdn.magicpatterns.com/uploads/7Tan4tCoZC26N1PHqU6F5U/панель_для_руководителя.png" alt="Дашборд Meelo — полный вид" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-297" />
            <p className="text-center text-white/40 text-xs mt-3 font-medium" data-id="element-298">
              Панель руководителя Meelo — нажми вне изображения, чтобы закрыть
            </p>
          </div>
        </div>}
    </div>;
}
// ── Mission 2 ──────────────────────────────────────────────────────────────
const M2_SCREENSHOTS = ['https://cdn.magicpatterns.com/uploads/8BE9aBQxMzEdYJY4P1zUS9/Screenshot_2026-02-18_at_23.32.30.png', 'https://cdn.magicpatterns.com/uploads/8XVKzRYhgkqPVgs8v3V9st/Screenshot_2026-02-19_at_11.01.39.png', 'https://cdn.magicpatterns.com/uploads/qxeU4Ka2BGZ9SbhaMdQ8hh/Screenshot_2026-02-19_at_11.02.29.png'];
const M2_HIGHLIGHTS = [{
  icon: '📋',
  text: 'Циклограмма — за минуты'
}, {
  icon: '📅',
  text: 'Перспективный план — автоматически'
}, {
  icon: '📝',
  text: 'Конспекты к ООД — без ручной рутины'
}, {
  icon: '✅',
  text: 'Документы всегда готовы к проверке'
}];
const M2_EVENING_TAGS = [{
  text: 'Циклограмма...',
  top: '8%',
  left: '4%',
  anim: 'chaos-float-1'
}, {
  text: 'Конспект к ООД',
  top: '5%',
  right: '4%',
  anim: 'chaos-float-2'
}, {
  text: '⚠️ Проверка завтра!',
  top: '50%',
  right: '3%',
  anim: 'chaos-float-3'
}, {
  text: 'Старый шаблон...',
  top: '46%',
  left: '3%',
  anim: 'chaos-float-4'
}];
// ── Swipeable screenshot gallery for Mission 2 ─────────────────────────────
function M2Gallery({
  onImageClick
}: {
  onImageClick: (idx: number) => void;
}) {
  const [active, setActive] = useState(0);
  const touchStartX = useRef<number | null>(null);
  const prev = () => setActive(i => (i - 1 + M2_SCREENSHOTS.length) % M2_SCREENSHOTS.length);
  const next = () => setActive(i => (i + 1) % M2_SCREENSHOTS.length);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 38) diff > 0 ? next() : prev();
    touchStartX.current = null;
  };
  return <div className="mb-4" data-id="element-299">
      {/* Gallery container */}
      <div className="relative rounded-2xl overflow-hidden border shadow-sm cursor-pointer select-none" style={{
      borderColor: '#FCE4EC'
    }} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} onClick={() => onImageClick(active)} data-id="element-300">
        {/* Browser chrome bar */}
        <div className="h-7 bg-gray-50 border-b border-gray-100 flex items-center px-3 gap-1.5 flex-shrink-0" data-id="element-301">
          <div className="w-2.5 h-2.5 rounded-full bg-red-400" data-id="element-302" />
          <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" data-id="element-303" />
          <div className="w-2.5 h-2.5 rounded-full bg-green-400" data-id="element-304" />
          <span className="ml-2 text-[10px] text-gray-400 font-medium" data-id="element-305">
            {active === 0 ? 'Циклограммы и планы' : active === 1 ? 'Конспекты к ООД' : 'Документы к проверке'}
          </span>
        </div>

        {/* Images with crossfade */}
        <div className="relative" data-id="element-306">
          {M2_SCREENSHOTS.map((src, i) => <img key={i} src={src} alt={`Методический блок — экран ${i + 1}`} className="w-full h-auto block" style={{
          position: i === 0 ? 'relative' : 'absolute',
          top: 0,
          left: 0,
          opacity: active === i ? 1 : 0,
          transition: 'opacity 260ms ease',
          pointerEvents: active === i ? 'auto' : 'none'
        }} data-id="element-307" />)}

          {/* Prev arrow */}
          <button onClick={e => {
          e.stopPropagation();
          prev();
        }} className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white/90 border border-gray-200 flex items-center justify-center shadow-sm z-10 hover:bg-white transition-colors" aria-label="Предыдущий" data-id="element-308">
            <ChevronLeft size={16} className="text-gray-600" data-id="element-309" />
          </button>

          {/* Next arrow */}
          <button onClick={e => {
          e.stopPropagation();
          next();
        }} className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white/90 border border-gray-200 flex items-center justify-center shadow-sm z-10 hover:bg-white transition-colors" aria-label="Следующий" data-id="element-310">
            <ChevronRight size={16} className="text-gray-600" data-id="element-311" />
          </button>

          {/* Zoom hint */}
          <div className="absolute bottom-2 right-2 flex items-center gap-1 bg-black/50 text-white text-[10px] font-medium px-2 py-1 rounded-lg backdrop-blur-sm pointer-events-none" data-id="element-312">
            🔍 Нажми для просмотра
          </div>

          {/* Swipe hint — only on first view */}
          {active === 0 && <div className="absolute bottom-2 left-2 flex items-center gap-1 bg-black/40 text-white text-[10px] font-medium px-2 py-1 rounded-lg backdrop-blur-sm pointer-events-none" style={{
          animation: 'fadeInUp 600ms ease forwards'
        }} data-id="element-313">
              ← свайп →
            </div>}
        </div>
      </div>

      {/* Dot indicators */}
      <div className="flex justify-center items-center gap-2 mt-2.5" data-id="element-314">
        {M2_SCREENSHOTS.map((_, i) => <button key={i} onClick={() => setActive(i)} aria-label={`Экран ${i + 1}`} style={{
        width: active === i ? 20 : 7,
        height: 7,
        borderRadius: 4,
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        background: active === i ? '#E91E63' : '#D1D5DB',
        transition: 'all 250ms ease'
      }} data-id="element-315" />)}
      </div>

      {/* Screen label */}
      <p className="text-center text-[11px] text-gray-400 font-medium mt-1.5" data-id="element-316">
        {active + 1} / {M2_SCREENSHOTS.length} — листай, чтобы увидеть больше
      </p>
    </div>;
}
type M2Phase = 'evening' | 'choice' | 'manual' | 'generating' | 'result';
function Mission2({
  onComplete
}: {
  onComplete: () => void;
}) {
  const [phase, setPhase] = useState<M2Phase>('evening');
  const [manualProgress, setManualProgress] = useState(0);
  const [meeloProgress, setMeeloProgress] = useState(0);
  const [genStep, setGenStep] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIdx, setLightboxIdx] = useState(0);
  const openLightbox = (idx: number) => {
    setLightboxIdx(idx);
    setLightboxOpen(true);
  };
  // Slow manual loading
  useEffect(() => {
    if (phase !== 'manual') return;
    setManualProgress(0);
    let p = 0;
    const iv = setInterval(() => {
      p += 0.4;
      setManualProgress(Math.min(p, 26));
      if (p >= 26) clearInterval(iv);
    }, 80);
    return () => clearInterval(iv);
  }, [phase]);
  // Fast Meelo generation
  useEffect(() => {
    if (phase !== 'generating') return;
    setMeeloProgress(0);
    setGenStep(0);
    let p = 0;
    const iv = setInterval(() => {
      p += 5;
      setMeeloProgress(Math.min(p, 100));
      if (p >= 100) clearInterval(iv);
    }, 55);
    const t1 = setTimeout(() => setGenStep(1), 250);
    const t2 = setTimeout(() => setGenStep(2), 550);
    const t3 = setTimeout(() => setGenStep(3), 850);
    const t4 = setTimeout(() => setGenStep(4), 1150);
    const t5 = setTimeout(() => setPhase('result'), 1800);
    return () => {
      clearInterval(iv);
      [t1, t2, t3, t4, t5].forEach(clearTimeout);
    };
  }, [phase]);
  // ── EVENING SCENE ──
  if (phase === 'evening') {
    return <div data-id="element-317">
        <div className="relative rounded-3xl overflow-hidden mb-4" style={{
        background: 'linear-gradient(180deg, #FFF8E1 0%, #FCE4EC 100%)',
        minHeight: 248
      }} data-id="element-318">
          <div className="absolute inset-0 pointer-events-none" style={{
          background: 'radial-gradient(ellipse 65% 55% at 50% 35%, rgba(255,200,80,0.22) 0%, transparent 65%)'
        }} data-id="element-319" />
          <div className="absolute top-3 left-3 flex items-center gap-1.5 rounded-full px-2.5 py-1" style={{
          background: 'rgba(255,255,255,0.82)',
          border: '1px solid rgba(251,146,60,0.35)',
          backdropFilter: 'blur(8px)'
        }} data-id="element-320">
            <span className="text-xs" data-id="element-321">🌙</span>
            <span className="text-xs font-bold text-amber-700 font-mono" data-id="element-322">
              19:47
            </span>
          </div>
          {M2_EVENING_TAGS.map((tag, i) => <div key={i} className="absolute text-[11px] font-semibold px-2.5 py-1.5 rounded-xl" style={{
          top: tag.top,
          left: (tag as any).left,
          right: (tag as any).right,
          background: 'rgba(255,255,255,0.78)',
          border: '1px solid rgba(251,146,60,0.32)',
          color: '#C2410C',
          backdropFilter: 'blur(6px)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
          animation: `${tag.anim} ${2.8 + i * 0.4}s ease-in-out infinite`,
          animationDelay: `${i * 0.5}s`,
          maxWidth: '46%',
          lineHeight: 1.35
        }} data-id="element-323">
              📄 {tag.text}
            </div>)}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-1" style={{
          marginTop: -16
        }} data-id="element-324">
            <div className="text-4xl" style={{
            animation: 'meelo-bounce 3.5s ease-in-out infinite'
          }} data-id="element-325">
              😔
            </div>
            <div className="text-3xl opacity-80" data-id="element-326">💻</div>
          </div>
          <div className="absolute bottom-4 left-4 right-4 flex items-end gap-3" style={{
          animation: 'fadeInUp 500ms ease forwards'
        }} data-id="element-327">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 shadow-lg" style={{
            background: 'rgba(255,255,255,0.95)',
            border: '2px solid rgba(255,255,255,0.9)',
            animation: 'meelo-bounce 2.2s ease-in-out infinite'
          }} data-id="element-328">
              <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-1" data-id="element-329" />
            </div>
            <div className="flex-1 rounded-3xl rounded-bl-lg px-4 py-3" style={{
            background: 'rgba(255,255,255,0.90)',
            backdropFilter: 'blur(16px)',
            border: '1.5px solid rgba(255,255,255,0.75)',
            boxShadow: '0 8px 28px rgba(200,80,80,0.12)'
          }} data-id="element-330">
              <p className="text-sm font-semibold text-[#7C2D12] leading-relaxed" data-id="element-331">
                Я вижу, как вы устали.
                <br data-id="element-332" />
                Давайте сделаем иначе.
              </p>
            </div>
          </div>
        </div>
        <div className="bg-rose-50 border border-rose-100 rounded-2xl px-4 py-3 mb-4" data-id="element-333">
          <p className="text-sm text-rose-700 font-semibold leading-relaxed text-center" data-id="element-334">
            Циклограммы вручную. Поздние вечера. Проверки — стресс.
          </p>
        </div>
        <button onClick={() => setPhase('choice')} className="w-full py-2.5 rounded-xl text-sm font-semibold transition-all active:scale-95" style={{
        background: 'rgba(255,255,255,0.88)',
        color: '#9A3412',
        border: '1.5px solid rgba(251,146,60,0.35)',
        boxShadow: '0 2px 12px rgba(200,100,50,0.1)'
      }} data-id="element-335">
          Продолжить ›
        </button>
      </div>;
  }
  // ── CHOICE ──
  if (phase === 'choice') {
    return <div style={{
      animation: 'fadeInUp 350ms ease forwards'
    }} data-id="element-336">
        <p className="text-xs text-gray-500 font-semibold mb-3 text-center uppercase tracking-wide" data-id="element-337">
          Как будем составлять документы?
        </p>
        <div className="grid grid-cols-2 gap-3 mb-2" data-id="element-338">
          <button onClick={() => setPhase('manual')} className="rounded-2xl p-4 text-left border-2 transition-all active:scale-95 hover:border-gray-300" style={{
          background: '#F9FAFB',
          borderColor: '#E5E7EB'
        }} data-id="element-339">
            <div className="text-2xl mb-2" data-id="element-340">📝</div>
            <p className="text-sm font-bold text-gray-700 leading-tight mb-1.5" data-id="element-341">
              Составить вручную
            </p>
            <p className="text-xs text-gray-400 font-medium" data-id="element-342">⏱ ~3 часа</p>
          </button>
          <button onClick={() => setPhase('generating')} className="rounded-2xl p-4 text-left border-2 transition-all active:scale-95 relative overflow-hidden" style={{
          background: 'linear-gradient(135deg, #F3EEFF 0%, #EEF4FF 100%)',
          borderColor: '#C4B5FD',
          boxShadow: '0 4px 20px rgba(124,77,255,0.18)'
        }} data-id="element-343">
            <div className="text-2xl mb-2" data-id="element-344">⚡</div>
            <p className="text-sm font-bold text-[#5B21B6] leading-tight mb-1.5" data-id="element-345">
              Собрать с Meelo
            </p>
            <p className="text-xs text-[#7C4DFF] font-bold" data-id="element-346">✨ ~5 секунд</p>
            <div className="absolute top-2 right-2 bg-[#7C4DFF] text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full leading-tight" data-id="element-347">
              ✓ Рекомендуем
            </div>
          </button>
        </div>
      </div>;
  }
  // ── MANUAL LOADING ──
  if (phase === 'manual') {
    return <div style={{
      animation: 'fadeInUp 350ms ease forwards'
    }} data-id="element-348">
        <div className="rounded-2xl bg-gray-50 border border-gray-200 p-5 mb-4" data-id="element-349">
          <div className="flex items-center justify-between mb-2" data-id="element-350">
            <p className="text-sm font-semibold text-gray-600" data-id="element-351">
              Составляю вручную...
            </p>
            <span className="text-xs font-mono text-gray-400" data-id="element-352">
              ~3 ч осталось
            </span>
          </div>
          <div className="h-2.5 bg-gray-200 rounded-full overflow-hidden mb-4" data-id="element-353">
            <div className="h-full rounded-full transition-all duration-200" style={{
            width: `${manualProgress}%`,
            background: 'linear-gradient(90deg, #9CA3AF, #6B7280)'
          }} data-id="element-354" />
          </div>
          <div className="flex flex-wrap gap-1.5" data-id="element-355">
            {['Открываю шаблон...', 'Копирую прошлый план...', 'Правлю даты...'].map((s, i) => <span key={i} className="text-[10px] text-gray-400 bg-gray-100 px-2 py-1 rounded-lg font-medium" data-id="element-356">
                {s}
              </span>)}
          </div>
        </div>
        {manualProgress >= 18 && <>
            <div className="bg-amber-50 border border-amber-100 rounded-2xl px-4 py-3 mb-4" style={{
          animation: 'fadeInUp 300ms ease forwards'
        }} data-id="element-357">
              <p className="text-sm text-amber-700 font-semibold text-center" data-id="element-358">
                Долго, правда? 😅 А ведь это каждую неделю...
              </p>
            </div>
            <button onClick={() => setPhase('generating')} className="w-full py-3 rounded-xl text-sm font-semibold bg-[#7C4DFF] text-white hover:bg-[#651FFF] transition-all active:scale-95" style={{
          animation: 'fadeInUp 400ms ease forwards',
          boxShadow: '0 0 22px rgba(124,77,255,0.38)'
        }} data-id="element-359">
              ⚡ Попробовать с Meelo →
            </button>
          </>}
      </div>;
  }
  // ── MEELO GENERATION ──
  if (phase === 'generating') {
    return <div style={{
      animation: 'fadeInUp 350ms ease forwards'
    }} data-id="element-360">
        <div className="rounded-2xl border p-5 mb-4" style={{
        background: 'linear-gradient(135deg, #F5F3FF 0%, #EEF4FF 100%)',
        borderColor: '#DDD6FE'
      }} data-id="element-361">
          <div className="flex items-center justify-between mb-2" data-id="element-362">
            <p className="text-sm font-bold text-[#5B21B6]" data-id="element-363">
              {meeloProgress < 100 ? '⚡ Meelo генерирует...' : '✓ Готово за 5 секунд!'}
            </p>
            <span className="text-xs font-mono font-bold text-[#7C4DFF]" data-id="element-364">
              {Math.round(meeloProgress)}%
            </span>
          </div>
          <div className="h-2.5 bg-[#EDE7F6] rounded-full overflow-hidden mb-4" data-id="element-365">
            <div className="h-full rounded-full transition-all duration-75" style={{
            width: `${meeloProgress}%`,
            background: 'linear-gradient(90deg, #7C4DFF, #B388FF)'
          }} data-id="element-366" />
          </div>
          <div className="flex flex-col gap-2" data-id="element-367">
            {M2_HIGHLIGHTS.map((item, i) => <div key={i} className="flex items-center gap-2.5 transition-all duration-300" style={{
            opacity: genStep > i ? 1 : 0.2,
            transform: genStep > i ? 'translateX(0)' : 'translateX(-6px)'
          }} data-id="element-368">
                <span className={`text-xs font-bold w-4 ${genStep > i ? 'text-[#7C4DFF]' : 'text-gray-300'}`} data-id="element-369">
                  {genStep > i ? '✓' : '○'}
                </span>
                <span className={`text-xs font-semibold ${genStep > i ? 'text-[#3D1A8A]' : 'text-gray-300'}`} data-id="element-370">
                  {item.text}
                </span>
              </div>)}
          </div>
        </div>
      </div>;
  }
  // ── RESULT ──
  return <div style={{
    animation: 'fadeInUp 400ms ease forwards'
  }} data-id="element-371">
      {/* Success banner */}
      <div className="flex items-center gap-3 bg-green-50 border border-green-100 rounded-2xl px-4 py-3 mb-4" data-id="element-372">
        <span className="text-xl" data-id="element-373">✨</span>
        <div data-id="element-374">
          <p className="text-sm font-bold text-green-700" data-id="element-375">
            Методический блок готов!
          </p>
          <p className="text-xs text-green-600 font-medium" data-id="element-376">
            3 экрана системы — листайте, чтобы увидеть всё
          </p>
        </div>
      </div>

      {/* Swipeable gallery */}
      <M2Gallery onImageClick={openLightbox} data-id="element-377" />

      {/* Highlights */}
      <div className="flex flex-col gap-2 mb-5" data-id="element-378">
        {M2_HIGHLIGHTS.map((item, i) => <div key={i} className="flex items-center gap-3 px-3 py-2.5 rounded-xl" style={{
        background: '#FFF0F6',
        border: '1.5px solid #FECDD3'
      }} data-id="element-379">
            <span className="text-base leading-none" data-id="element-380">{item.icon}</span>
            <p className="text-sm font-medium text-[#9D174D] flex-1" data-id="element-381">
              {item.text}
            </p>
            <Check size={14} color="#E91E63" strokeWidth={2.5} className="flex-shrink-0" data-id="element-382" />
          </div>)}
      </div>

      <button onClick={onComplete} className="w-full py-3 rounded-xl text-sm font-semibold text-white transition-all shadow-lg active:scale-95" style={{
      background: 'linear-gradient(135deg, #FF4081 0%, #E91E63 100%)',
      boxShadow: '0 4px 20px rgba(233,30,99,0.35)'
    }} data-id="element-383">
        Завершить миссию →
      </button>

      {/* Lightbox */}
      {lightboxOpen && <div className="fixed inset-0 z-[200] flex items-center justify-center p-4" style={{
      background: 'rgba(0,0,0,0.92)',
      backdropFilter: 'blur(6px)',
      animation: 'fadeInUp 200ms ease forwards'
    }} onClick={() => setLightboxOpen(false)} data-id="element-384">
          <div className="relative w-full max-w-3xl" onClick={e => e.stopPropagation()} data-id="element-385">
            {/* Lightbox nav */}
            <div className="flex items-center justify-between mb-3" data-id="element-386">
              <div className="flex gap-1.5" data-id="element-387">
                {M2_SCREENSHOTS.map((_, i) => <button key={i} onClick={() => setLightboxIdx(i)} style={{
              width: i === lightboxIdx ? 20 : 7,
              height: 7,
              borderRadius: 4,
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              background: i === lightboxIdx ? '#E91E63' : 'rgba(255,255,255,0.3)',
              transition: 'all 200ms'
            }} data-id="element-388" />)}
              </div>
              <button onClick={() => setLightboxOpen(false)} className="flex items-center gap-1.5 text-white/60 hover:text-white text-sm font-medium transition-colors" data-id="element-389">
                <X size={16} data-id="element-390" /> Закрыть
              </button>
            </div>
            <div className="relative" data-id="element-391">
              <img src={M2_SCREENSHOTS[lightboxIdx]} alt={`Экран ${lightboxIdx + 1}`} className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-392" />
              {/* Lightbox prev/next */}
              {lightboxIdx > 0 && <button onClick={() => setLightboxIdx(i => i - 1)} className="absolute left-2 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white/20 hover:bg-white/35 flex items-center justify-center transition-colors" data-id="element-393">
                  <ChevronLeft size={18} className="text-white" data-id="element-394" />
                </button>}
              {lightboxIdx < M2_SCREENSHOTS.length - 1 && <button onClick={() => setLightboxIdx(i => i + 1)} className="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white/20 hover:bg-white/35 flex items-center justify-center transition-colors" data-id="element-395">
                  <ChevronRight size={18} className="text-white" data-id="element-396" />
                </button>}
            </div>
            <p className="text-center text-white/40 text-xs mt-3 font-medium" data-id="element-397">
              {lightboxIdx + 1} / {M2_SCREENSHOTS.length} — нажми вне
              изображения, чтобы закрыть
            </p>
          </div>
        </div>}
    </div>;
}
// ── Mission 3 ──────────────────────────────────────────────────────────────
const M3_HIGHLIGHTS = [{
  icon: '🍽️',
  text: 'Перспективное меню — автоматически'
}, {
  icon: '📋',
  text: 'Техкарты формируются сами'
}, {
  icon: '🛒',
  text: 'Закуп рассчитывается по калькуляции'
}, {
  icon: '✂️',
  text: 'Списание без ручной рутины'
}, {
  icon: '📓',
  text: 'Пищевые журналы ведутся автоматически'
}];
const M3_CHAOS_TAGS = [{
  text: '📊 Excel меню',
  top: '7%',
  left: '3%',
  anim: 'chaos-float-1'
}, {
  text: '🧮 Калькулятор',
  top: '5%',
  right: '4%',
  anim: 'chaos-float-2'
}, {
  text: '📁 Журналы',
  top: '48%',
  left: '2%',
  anim: 'chaos-float-3'
}, {
  text: '📋 Техкарты вручную',
  top: '44%',
  right: '2%',
  anim: 'chaos-float-4'
}];
const M3_ERROR_TAGS = [{
  text: '❌ Ошибка в раскладке',
  top: '8%',
  left: '3%',
  anim: 'chaos-float-1'
}, {
  text: '❌ Закуп не сходится',
  top: '5%',
  right: '3%',
  anim: 'chaos-float-2'
}, {
  text: '⚠️ Журнал не заполнен',
  top: '48%',
  left: '2%',
  anim: 'chaos-float-3'
}, {
  text: '⚠️ Санпроверка завтра!',
  top: '44%',
  right: '2%',
  anim: 'chaos-float-4'
}];
type M3Phase = 'chaos' | 'errors' | 'generating' | 'result';
function Mission3({
  onComplete
}: {
  onComplete: () => void;
}) {
  const [phase, setPhase] = useState<M3Phase>('chaos');
  const [meeloProgress, setMeeloProgress] = useState(0);
  const [genStep, setGenStep] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  // Fast Meelo generation
  useEffect(() => {
    if (phase !== 'generating') return;
    setMeeloProgress(0);
    setGenStep(0);
    let p = 0;
    const iv = setInterval(() => {
      p += 4;
      setMeeloProgress(Math.min(p, 100));
      if (p >= 100) clearInterval(iv);
    }, 55);
    const t1 = setTimeout(() => setGenStep(1), 200);
    const t2 = setTimeout(() => setGenStep(2), 500);
    const t3 = setTimeout(() => setGenStep(3), 800);
    const t4 = setTimeout(() => setGenStep(4), 1100);
    const t5 = setTimeout(() => setGenStep(5), 1400);
    const t6 = setTimeout(() => setPhase('result'), 2000);
    return () => {
      clearInterval(iv);
      [t1, t2, t3, t4, t5, t6].forEach(clearTimeout);
    };
  }, [phase]);
  // ── CHAOS SCENE ──
  if (phase === 'chaos') {
    return <div data-id="element-398">
        <div className="relative rounded-3xl overflow-hidden mb-4" style={{
        background: 'linear-gradient(180deg, #F1F8E9 0%, #DCEDC8 100%)',
        minHeight: 248
      }} data-id="element-399">
          {/* Warm kitchen glow */}
          <div className="absolute inset-0 pointer-events-none" style={{
          background: 'radial-gradient(ellipse 65% 55% at 50% 35%, rgba(180,230,120,0.25) 0%, transparent 65%)'
        }} data-id="element-400" />

          {/* Floating chaos tags */}
          {M3_CHAOS_TAGS.map((tag, i) => <div key={i} className="absolute text-[11px] font-semibold px-2.5 py-1.5 rounded-xl" style={{
          top: tag.top,
          left: (tag as any).left,
          right: (tag as any).right,
          background: 'rgba(255,255,255,0.80)',
          border: '1px solid rgba(180,83,9,0.28)',
          color: '#92400E',
          backdropFilter: 'blur(6px)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
          animation: `${tag.anim} ${2.8 + i * 0.4}s ease-in-out infinite`,
          animationDelay: `${i * 0.5}s`,
          maxWidth: '48%',
          lineHeight: 1.35
        }} data-id="element-401">
              {tag.text}
            </div>)}

          {/* Desk scene */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-1" style={{
          marginTop: -12
        }} data-id="element-402">
            <div className="flex gap-2 text-3xl mb-1" data-id="element-403">
              <span style={{
              animation: 'chaos-float-2 3s ease-in-out infinite'
            }} data-id="element-404">
                📄
              </span>
              <span style={{
              animation: 'chaos-float-1 3.5s ease-in-out infinite',
              animationDelay: '0.5s'
            }} data-id="element-405">
                📄
              </span>
              <span style={{
              animation: 'chaos-float-3 2.8s ease-in-out infinite',
              animationDelay: '1s'
            }} data-id="element-406">
                📄
              </span>
            </div>
            <div className="text-3xl opacity-80" data-id="element-407">🖥️</div>
          </div>

          {/* Hint */}
          <p className="absolute top-3 right-3 text-[11px] text-green-700/50 font-medium pointer-events-none" style={{
          animation: 'chaos-float-3 3s ease-in-out infinite'
        }} data-id="element-408">
            Нажмите, чтобы продолжить →
          </p>
        </div>

        {/* Stress text */}
        <div className="bg-amber-50 border border-amber-100 rounded-2xl px-4 py-3 mb-4" data-id="element-409">
          <p className="text-sm text-amber-800 font-semibold leading-relaxed text-center" data-id="element-410">
            Меню вручную. Закуп вручную. Списание вручную.
          </p>
        </div>

        <button onClick={() => setPhase('errors')} className="w-full py-3 rounded-xl text-sm font-semibold transition-all active:scale-95" style={{
        background: '#F9FAFB',
        color: '#374151',
        border: '1.5px solid #E5E7EB',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
      }} data-id="element-411">
          🧮 Рассчитать вручную
        </button>
      </div>;
  }
  // ── ERRORS SCENE ──
  if (phase === 'errors') {
    return <div style={{
      animation: 'fadeInUp 300ms ease forwards'
    }} data-id="element-412">
        <div className="relative rounded-3xl overflow-hidden mb-4" style={{
        background: 'linear-gradient(180deg, #FFF1F2 0%, #FFE4E6 100%)',
        minHeight: 248
      }} data-id="element-413">
          {/* Red glow */}
          <div className="absolute inset-0 pointer-events-none" style={{
          background: 'radial-gradient(ellipse 65% 55% at 50% 35%, rgba(254,100,100,0.15) 0%, transparent 65%)'
        }} data-id="element-414" />

          {/* Error tags */}
          {M3_ERROR_TAGS.map((tag, i) => <div key={i} className="absolute text-[11px] font-semibold px-2.5 py-1.5 rounded-xl" style={{
          top: tag.top,
          left: (tag as any).left,
          right: (tag as any).right,
          background: 'rgba(255,255,255,0.82)',
          border: '1px solid rgba(220,38,38,0.35)',
          color: '#DC2626',
          backdropFilter: 'blur(6px)',
          boxShadow: '0 2px 8px rgba(220,38,38,0.10)',
          animation: `${tag.anim} ${2.4 + i * 0.35}s ease-in-out infinite`,
          animationDelay: `${i * 0.4}s`,
          maxWidth: '52%',
          lineHeight: 1.35
        }} data-id="element-415">
              {tag.text}
            </div>)}

          {/* Panic scene */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-1" style={{
          marginTop: -12
        }} data-id="element-416">
            <div className="text-4xl" style={{
            animation: 'meelo-bounce 1.5s ease-in-out infinite'
          }} data-id="element-417">
              😰
            </div>
            <div className="text-2xl opacity-70" data-id="element-418">💻</div>
          </div>

          {/* Meelo speech bubble */}
          <div className="absolute bottom-4 left-4 right-4 flex items-end gap-3" style={{
          animation: 'fadeInUp 400ms ease forwards'
        }} data-id="element-419">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 shadow-lg" style={{
            background: 'rgba(255,255,255,0.95)',
            border: '2px solid rgba(255,255,255,0.9)',
            animation: 'meelo-bounce 2.2s ease-in-out infinite'
          }} data-id="element-420">
              <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-1" data-id="element-421" />
            </div>
            <div className="flex-1 rounded-3xl rounded-bl-lg px-4 py-3" style={{
            background: 'rgba(255,255,255,0.92)',
            backdropFilter: 'blur(16px)',
            border: '1.5px solid rgba(255,255,255,0.75)',
            boxShadow: '0 8px 28px rgba(220,38,38,0.10)'
          }} data-id="element-422">
              <p className="text-sm font-semibold text-[#166534] leading-relaxed" data-id="element-423">
                Давайте автоматизируем питание.
                <br data-id="element-424" />
                <span className="text-green-600 font-bold" data-id="element-425">
                  Один раз настроим — и всё само.
                </span>
              </p>
            </div>
          </div>
        </div>

        {/* Error summary */}
        <div className="bg-red-50 border border-red-100 rounded-2xl px-4 py-3 mb-4" data-id="element-426">
          <p className="text-sm text-red-700 font-semibold leading-relaxed text-center" data-id="element-427">
            Ошибки в расчётах. Журналы не заполнены. Санпроверка — стресс.
          </p>
        </div>

        <button onClick={() => setPhase('generating')} className="w-full py-3 rounded-xl text-sm font-semibold text-white transition-all active:scale-95" style={{
        background: 'linear-gradient(135deg, #43A047 0%, #2E7D32 100%)',
        boxShadow: '0 0 22px rgba(67,160,71,0.40)'
      }} data-id="element-428">
          ⚡ Включить автопитание
        </button>
      </div>;
  }
  // ── GENERATION ──
  if (phase === 'generating') {
    return <div style={{
      animation: 'fadeInUp 350ms ease forwards'
    }} data-id="element-429">
        <div className="rounded-2xl border p-5 mb-4" style={{
        background: 'linear-gradient(135deg, #F0FDF4 0%, #ECFDF5 100%)',
        borderColor: '#BBF7D0'
      }} data-id="element-430">
          <div className="flex items-center justify-between mb-2" data-id="element-431">
            <p className="text-sm font-bold text-[#166534]" data-id="element-432">
              {meeloProgress < 100 ? '⚡ Meelo настраивает питание...' : '✓ Готово!'}
            </p>
            <span className="text-xs font-mono font-bold text-green-600" data-id="element-433">
              {Math.round(meeloProgress)}%
            </span>
          </div>
          <div className="h-2.5 bg-green-100 rounded-full overflow-hidden mb-4" data-id="element-434">
            <div className="h-full rounded-full transition-all duration-75" style={{
            width: `${meeloProgress}%`,
            background: 'linear-gradient(90deg, #43A047, #A5D6A7)'
          }} data-id="element-435" />
          </div>
          <div className="flex flex-col gap-2" data-id="element-436">
            {M3_HIGHLIGHTS.map((item, i) => <div key={i} className="flex items-center gap-2.5 transition-all duration-300" style={{
            opacity: genStep > i ? 1 : 0.2,
            transform: genStep > i ? 'translateX(0)' : 'translateX(-6px)'
          }} data-id="element-437">
                <span className={`text-xs font-bold w-4 ${genStep > i ? 'text-green-600' : 'text-gray-300'}`} data-id="element-438">
                  {genStep > i ? '✓' : '○'}
                </span>
                <span className={`text-xs font-semibold ${genStep > i ? 'text-[#166534]' : 'text-gray-300'}`} data-id="element-439">
                  {item.text}
                </span>
              </div>)}
          </div>
        </div>
      </div>;
  }
  // ── RESULT ──
  return <div style={{
    animation: 'fadeInUp 400ms ease forwards'
  }} data-id="element-440">
      {/* Success banner */}
      <div className="flex items-center gap-3 bg-green-50 border border-green-100 rounded-2xl px-4 py-3 mb-4" data-id="element-441">
        <span className="text-xl" data-id="element-442">🍽️</span>
        <div data-id="element-443">
          <p className="text-sm font-bold text-green-700" data-id="element-444">
            От меню до списания — всё под контролем.
          </p>
          <p className="text-xs text-green-600 font-medium" data-id="element-445">
            Питание автоматизировано полностью
          </p>
        </div>
      </div>

      {/* Screenshot */}
      <div className="relative rounded-2xl overflow-hidden mb-4 border cursor-zoom-in shadow-sm" style={{
      borderColor: '#BBF7D0'
    }} onClick={() => setLightboxOpen(true)} data-id="element-446">
        <div className="h-7 bg-gray-50 border-b border-gray-100 flex items-center px-3 gap-1.5" data-id="element-447">
          <div className="w-2.5 h-2.5 rounded-full bg-red-400" data-id="element-448" />
          <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" data-id="element-449" />
          <div className="w-2.5 h-2.5 rounded-full bg-green-400" data-id="element-450" />
          <span className="ml-2 text-[10px] text-gray-400 font-medium" data-id="element-451">
            Питание и склад — Meelo
          </span>
        </div>
        <img src="https://cdn.magicpatterns.com/uploads/wGEXkWBfz5D1U5Hv1vr71s/склад.png" alt="Система питания и склада Meelo" className="w-full h-auto block" data-id="element-452" />
        <div className="absolute inset-0 pointer-events-none" style={{
        background: 'linear-gradient(135deg, rgba(67,160,71,0.06) 0%, transparent 55%)',
        animation: 'dashboard-glow 3s ease-in-out infinite'
      }} data-id="element-453" />
        <div className="absolute bottom-2 right-2 flex items-center gap-1 bg-black/50 text-white text-[10px] font-medium px-2 py-1 rounded-lg backdrop-blur-sm pointer-events-none" data-id="element-454">
          🔍 Нажми для просмотра
        </div>
      </div>

      {/* Highlights */}
      <div className="flex flex-col gap-2 mb-5" data-id="element-455">
        {M3_HIGHLIGHTS.map((item, i) => <div key={i} className="flex items-center gap-3 px-3 py-2.5 rounded-xl" style={{
        background: '#F0FDF4',
        border: '1.5px solid #BBF7D0'
      }} data-id="element-456">
            <span className="text-base leading-none" data-id="element-457">{item.icon}</span>
            <p className="text-sm font-medium text-[#166534] flex-1" data-id="element-458">
              {item.text}
            </p>
            <Check size={14} color="#16A34A" strokeWidth={2.5} className="flex-shrink-0" data-id="element-459" />
          </div>)}
      </div>

      <button onClick={onComplete} className="w-full py-3 rounded-xl text-sm font-semibold text-white transition-all shadow-lg active:scale-95" style={{
      background: 'linear-gradient(135deg, #43A047 0%, #2E7D32 100%)',
      boxShadow: '0 4px 20px rgba(67,160,71,0.38)'
    }} data-id="element-460">
        Завершить миссию →
      </button>

      {/* Lightbox */}
      {lightboxOpen && <div className="fixed inset-0 z-[200] flex items-center justify-center p-4" style={{
      background: 'rgba(0,0,0,0.92)',
      backdropFilter: 'blur(6px)',
      animation: 'fadeInUp 200ms ease forwards'
    }} onClick={() => setLightboxOpen(false)} data-id="element-461">
          <div className="relative w-full max-w-3xl" onClick={e => e.stopPropagation()} data-id="element-462">
            <button onClick={() => setLightboxOpen(false)} className="absolute -top-10 right-0 flex items-center gap-1.5 text-white/60 hover:text-white text-sm font-medium transition-colors" data-id="element-463">
              <X size={16} data-id="element-464" /> Закрыть
            </button>
            <img src="https://cdn.magicpatterns.com/uploads/wGEXkWBfz5D1U5Hv1vr71s/склад.png" alt="Питание и склад — полный вид" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-465" />
            <p className="text-center text-white/40 text-xs mt-3 font-medium" data-id="element-466">
              Нажми вне изображения, чтобы закрыть
            </p>
          </div>
        </div>}
    </div>;
}
// ── Mission 4 ──────────────────────────────────────────────────────────────
const M4_MSGS_WAVE1 = [{
  text: 'А был ли мой ребёнок?',
  sender: 'Мама Алины',
  top: '7%',
  left: '2%',
  anim: 'chaos-float-1'
}, {
  text: 'Что сегодня ели?',
  sender: 'Папа Димы',
  top: '5%',
  right: '2%',
  anim: 'chaos-float-2'
}, {
  text: 'Когда будут фото?',
  sender: 'Мама Саши',
  top: '50%',
  left: '1%',
  anim: 'chaos-float-3'
}, {
  text: 'Почему не ответили?',
  sender: 'Мама Лизы',
  top: '46%',
  right: '1%',
  anim: 'chaos-float-4'
}];
const M4_MSGS_WAVE2 = [{
  text: 'Есть ли меню на неделю?',
  sender: 'Папа Артёма',
  top: '24%',
  left: '3%',
  anim: 'chaos-float-2'
}, {
  text: 'Ребёнок сегодня поел?',
  sender: 'Мама Вани',
  top: '21%',
  right: '3%',
  anim: 'chaos-float-1'
}, {
  text: 'Когда следующее занятие?',
  sender: 'Мама Кати',
  top: '66%',
  left: '2%',
  anim: 'chaos-float-3'
}, {
  text: 'Можно посмотреть камеру?',
  sender: 'Папа Миши',
  top: '63%',
  right: '2%',
  anim: 'chaos-float-4'
}];
const M4_FEATURES = [{
  icon: '📸',
  text: 'Лента дня'
}, {
  icon: '🍽️',
  text: 'Меню'
}, {
  icon: '📅',
  text: 'Расписание'
}, {
  icon: '💬',
  text: 'Обращения'
}, {
  icon: '📹',
  text: 'Видеокамеры'
}];
type M4Phase = 'messages' | 'overwhelmed' | 'generating' | 'result';
// Chat bubble component
function ChatBubble({
  msg,
  delay = 0
}: {
  msg: (typeof M4_MSGS_WAVE1)[0];
  delay?: number;
}) {
  return <div className="absolute" style={{
    top: msg.top,
    left: (msg as any).left,
    right: (msg as any).right,
    maxWidth: '46%',
    animation: `${msg.anim} ${2.8}s ease-in-out infinite`,
    animationDelay: `${delay}s`
  }} data-id="element-467">
      <div className="rounded-2xl rounded-tl-sm px-2.5 py-1.5 shadow-sm" style={{
      background: 'rgba(255,255,255,0.90)',
      border: '1px solid rgba(37,99,235,0.18)',
      backdropFilter: 'blur(6px)'
    }} data-id="element-468">
        <p className="text-[9px] font-bold text-blue-500 mb-0.5 leading-none" data-id="element-469">
          {msg.sender}
        </p>
        <p className="text-[11px] font-semibold text-gray-700 leading-snug" data-id="element-470">
          {msg.text}
        </p>
      </div>
    </div>;
}
function Mission4({
  onComplete
}: {
  onComplete: () => void;
}) {
  const [phase, setPhase] = useState<M4Phase>('messages');
  const [meeloProgress, setMeeloProgress] = useState(0);
  const [genStep, setGenStep] = useState(0);
  const [resultStep, setResultStep] = useState(0);
  // Fast generation
  useEffect(() => {
    if (phase !== 'generating') return;
    setMeeloProgress(0);
    setGenStep(0);
    let p = 0;
    const iv = setInterval(() => {
      p += 5;
      setMeeloProgress(Math.min(p, 100));
      if (p >= 100) clearInterval(iv);
    }, 55);
    const timers = M4_FEATURES.map((_, i) => setTimeout(() => setGenStep(i + 1), 200 + i * 300));
    const done = setTimeout(() => setPhase('result'), 200 + M4_FEATURES.length * 300 + 500);
    return () => {
      clearInterval(iv);
      [...timers, done].forEach(clearTimeout);
    };
  }, [phase]);
  // Staggered result feature reveal
  useEffect(() => {
    if (phase !== 'result') return;
    setResultStep(0);
    const timers = M4_FEATURES.map((_, i) => setTimeout(() => setResultStep(i + 1), 200 + i * 200));
    return () => timers.forEach(clearTimeout);
  }, [phase]);
  // ── PHASE 1: MESSAGES ──
  if (phase === 'messages') {
    return <div data-id="element-471">
        <div className="relative rounded-3xl overflow-hidden mb-4" style={{
        background: 'linear-gradient(180deg, #E3F2FD 0%, #E8EAF6 100%)',
        minHeight: 260
      }} data-id="element-472">
          <div className="absolute inset-0 pointer-events-none" style={{
          background: 'radial-gradient(ellipse 65% 55% at 50% 35%, rgba(100,160,255,0.18) 0%, transparent 65%)'
        }} data-id="element-473" />

          {/* Wave 1 chat bubbles */}
          {M4_MSGS_WAVE1.map((msg, i) => <ChatBubble key={i} msg={msg} delay={i * 0.45} data-id="element-474" />)}

          {/* Notification badge */}
          <div className="absolute top-3 right-3 flex items-center gap-1.5 rounded-full px-2.5 py-1" style={{
          background: 'rgba(239,68,68,0.9)',
          animation: 'meelo-bounce 1.8s ease-in-out infinite'
        }} data-id="element-475">
            <span className="text-white text-[10px] font-bold" data-id="element-476">
              🔔 +24 сообщения
            </span>
          </div>

          {/* Stressed teacher */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-1" style={{
          marginTop: -10
        }} data-id="element-477">
            <div className="text-4xl" style={{
            animation: 'meelo-bounce 2.5s ease-in-out infinite'
          }} data-id="element-478">
              😓
            </div>
            <div className="text-2xl opacity-70" data-id="element-479">📱</div>
          </div>

          <p className="absolute top-3 left-3 text-[11px] text-blue-400/60 font-medium pointer-events-none" style={{
          animation: 'chaos-float-3 3s ease-in-out infinite'
        }} data-id="element-480">
            Нажмите, чтобы продолжить →
          </p>
        </div>

        <div className="bg-blue-50 border border-blue-100 rounded-2xl px-4 py-3 mb-4" data-id="element-481">
          <p className="text-sm text-blue-800 font-semibold leading-relaxed text-center" data-id="element-482">
            Слишком много сообщений. Одни и те же вопросы. Каждый день.
          </p>
        </div>

        <button onClick={() => setPhase('overwhelmed')} className="w-full py-3 rounded-xl text-sm font-semibold transition-all active:scale-95" style={{
        background: '#F9FAFB',
        color: '#374151',
        border: '1.5px solid #E5E7EB'
      }} data-id="element-483">
          💬 Ответить вручную
        </button>
      </div>;
  }
  // ── PHASE 2: OVERWHELMED ──
  if (phase === 'overwhelmed') {
    return <div style={{
      animation: 'fadeInUp 300ms ease forwards'
    }} data-id="element-484">
        <div className="relative rounded-3xl overflow-hidden mb-4" style={{
        background: 'linear-gradient(180deg, #FFF3E0 0%, #FFE0B2 100%)',
        minHeight: 280
      }} data-id="element-485">
          <div className="absolute inset-0 pointer-events-none" style={{
          background: 'radial-gradient(ellipse 65% 55% at 50% 35%, rgba(255,160,50,0.18) 0%, transparent 65%)'
        }} data-id="element-486" />

          {/* All 8 messages */}
          {[...M4_MSGS_WAVE1, ...M4_MSGS_WAVE2].map((msg, i) => <ChatBubble key={i} msg={msg} delay={i * 0.3} data-id="element-487" />)}

          {/* Exploding notification */}
          <div className="absolute top-3 right-3 flex items-center gap-1.5 rounded-full px-2.5 py-1" style={{
          background: 'rgba(239,68,68,0.95)',
          boxShadow: '0 0 12px rgba(239,68,68,0.5)',
          animation: 'meelo-bounce 1.2s ease-in-out infinite'
        }} data-id="element-488">
            <span className="text-white text-[10px] font-bold" data-id="element-489">
              🔔 +47 сообщений!
            </span>
          </div>

          {/* Overwhelmed teacher */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-1" style={{
          marginTop: -10
        }} data-id="element-490">
            <div className="text-4xl" style={{
            animation: 'meelo-bounce 1.2s ease-in-out infinite'
          }} data-id="element-491">
              😱
            </div>
            <div className="text-2xl opacity-70" data-id="element-492">📱</div>
          </div>

          {/* Meelo speech bubble */}
          <div className="absolute bottom-4 left-4 right-4 flex items-end gap-3" style={{
          animation: 'fadeInUp 400ms ease forwards'
        }} data-id="element-493">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 shadow-lg" style={{
            background: 'rgba(255,255,255,0.95)',
            border: '2px solid rgba(255,255,255,0.9)',
            animation: 'meelo-bounce 2.2s ease-in-out infinite'
          }} data-id="element-494">
              <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-1" data-id="element-495" />
            </div>
            <div className="flex-1 rounded-3xl rounded-bl-lg px-4 py-3" style={{
            background: 'rgba(255,255,255,0.92)',
            backdropFilter: 'blur(16px)',
            border: '1.5px solid rgba(255,255,255,0.75)',
            boxShadow: '0 8px 28px rgba(255,140,0,0.12)'
          }} data-id="element-496">
              <p className="text-sm font-semibold text-[#1E3A5F] leading-relaxed" data-id="element-497">
                Давайте сделаем общение прозрачным.
                <br data-id="element-498" />
                <span className="text-blue-600 font-bold" data-id="element-499">
                  Родители сами найдут ответы.
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="bg-orange-50 border border-orange-100 rounded-2xl px-4 py-3 mb-4" data-id="element-500">
          <p className="text-sm text-orange-800 font-semibold leading-relaxed text-center" data-id="element-501">
            Энергия уходит на ответы. А не на детей.
          </p>
        </div>

        <button onClick={() => setPhase('generating')} className="w-full py-3 rounded-xl text-sm font-semibold text-white transition-all active:scale-95" style={{
        background: 'linear-gradient(135deg, #2979FF 0%, #1565C0 100%)',
        boxShadow: '0 0 22px rgba(41,121,255,0.40)'
      }} data-id="element-502">
          🚀 Открыть родительский портал
        </button>
      </div>;
  }
  // ── PHASE 3: GENERATING ──
  if (phase === 'generating') {
    return <div style={{
      animation: 'fadeInUp 350ms ease forwards'
    }} data-id="element-503">
        <div className="rounded-2xl border p-5 mb-4" style={{
        background: 'linear-gradient(135deg, #EFF6FF 0%, #EEF2FF 100%)',
        borderColor: '#BFDBFE'
      }} data-id="element-504">
          <div className="flex items-center justify-between mb-2" data-id="element-505">
            <p className="text-sm font-bold text-[#1E40AF]" data-id="element-506">
              {meeloProgress < 100 ? '🚀 Открываем портал...' : '✓ Портал готов!'}
            </p>
            <span className="text-xs font-mono font-bold text-blue-600" data-id="element-507">
              {Math.round(meeloProgress)}%
            </span>
          </div>
          <div className="h-2.5 bg-blue-100 rounded-full overflow-hidden mb-4" data-id="element-508">
            <div className="h-full rounded-full transition-all duration-75" style={{
            width: `${meeloProgress}%`,
            background: 'linear-gradient(90deg, #2979FF, #82B1FF)'
          }} data-id="element-509" />
          </div>
          <div className="flex flex-col gap-2" data-id="element-510">
            {M4_FEATURES.map((item, i) => <div key={i} className="flex items-center gap-2.5 transition-all duration-300" style={{
            opacity: genStep > i ? 1 : 0.2,
            transform: genStep > i ? 'translateX(0)' : 'translateX(-6px)'
          }} data-id="element-511">
                <span className={`text-xs font-bold w-4 ${genStep > i ? 'text-blue-600' : 'text-gray-300'}`} data-id="element-512">
                  {genStep > i ? '✓' : '○'}
                </span>
                <span className="text-base leading-none" data-id="element-513">{item.icon}</span>
                <span className={`text-xs font-semibold ${genStep > i ? 'text-[#1E40AF]' : 'text-gray-300'}`} data-id="element-514">
                  {item.text}
                </span>
              </div>)}
          </div>
        </div>
      </div>;
  }
  // ── PHASE 4: RESULT ──
  return <div style={{
    animation: 'fadeInUp 400ms ease forwards'
  }} data-id="element-515">
      {/* Success banner */}
      <div className="flex items-center gap-3 bg-blue-50 border border-blue-100 rounded-2xl px-4 py-3 mb-4" data-id="element-516">
        <span className="text-xl" data-id="element-517">💙</span>
        <div data-id="element-518">
          <p className="text-sm font-bold text-blue-800" data-id="element-519">
            Родители спокойны. Вы сосредоточены на детях.
          </p>
          <p className="text-xs text-blue-600 font-medium" data-id="element-520">
            Портал открыт — вопросы решаются сами
          </p>
        </div>
      </div>

      {/* Phone mockups */}
      <div className="rounded-3xl mb-4 flex items-center justify-center relative overflow-hidden" style={{
      background: 'linear-gradient(135deg, #E3F2FD 0%, #E8EAF6 100%)',
      minHeight: 200,
      padding: '16px 0 8px'
    }} data-id="element-521">
        {/* Soft glow */}
        <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse 70% 60% at 50% 50%, rgba(41,121,255,0.10) 0%, transparent 70%)'
      }} data-id="element-522" />

        <div className="relative flex items-end justify-center" style={{
        height: 180,
        width: '100%'
      }} data-id="element-523">
          {/* Back phone */}
          <img src="https://cdn.magicpatterns.com/uploads/72Lf8Yrm1xA7wzLU6cnKZw/Mockuuups_Free_Transparent_iPhone_Air_Mockup.png" alt="Родительское приложение" style={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-108%) rotate(-6deg)',
          height: 148,
          opacity: 0.78,
          filter: 'drop-shadow(0 6px 16px rgba(0,0,0,0.12))'
        }} data-id="element-524" />
          {/* Front phone */}
          <img src="https://cdn.magicpatterns.com/uploads/m64wkFNvbCAXCjaTobC78V/Mockuuups_Free_Transparent_iPhone_Air_Mockup.png" alt="Лента дня" style={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-28%)',
          height: 168,
          filter: 'drop-shadow(0 10px 28px rgba(41,121,255,0.22))',
          zIndex: 2
        }} data-id="element-525" />
        </div>
      </div>

      {/* Feature pills — staggered reveal */}
      <div className="flex flex-wrap gap-2 mb-5 justify-center" data-id="element-526">
        {M4_FEATURES.map((item, i) => <div key={i} className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all duration-400" style={{
        opacity: resultStep > i ? 1 : 0,
        transform: resultStep > i ? 'translateY(0) scale(1)' : 'translateY(6px) scale(0.95)',
        background: '#EFF6FF',
        border: '1.5px solid #BFDBFE',
        color: '#1E40AF',
        transitionDelay: `${i * 80}ms`
      }} data-id="element-527">
            <span data-id="element-528">{item.icon}</span>
            <span data-id="element-529">{item.text}</span>
            <Check size={11} color="#2979FF" strokeWidth={3} data-id="element-530" />
          </div>)}
      </div>

      <button onClick={onComplete} className="w-full py-3 rounded-xl text-sm font-semibold text-white transition-all shadow-lg active:scale-95" style={{
      background: 'linear-gradient(135deg, #2979FF 0%, #1565C0 100%)',
      boxShadow: '0 4px 20px rgba(41,121,255,0.38)'
    }} data-id="element-531">
        Завершить миссию →
      </button>
    </div>;
}
// ── Building SVG Illustrations ─────────────────────────────────────────────
function CastleSVG() {
  return <svg viewBox="0 0 80 92" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-532">
      {/* Shadow */}
      <ellipse cx="40" cy="88" rx="30" ry="5" fill="rgba(0,0,0,0.12)" data-id="element-533" />
      {/* Left tower */}
      <rect x="4" y="28" width="15" height="56" rx="3" fill="#7C4DFF" data-id="element-534" />
      {/* Right tower */}
      <rect x="61" y="28" width="15" height="56" rx="3" fill="#7C4DFF" data-id="element-535" />
      {/* Left battlements */}
      <rect x="3" y="21" width="4" height="9" rx="1" fill="#651FFF" data-id="element-536" />
      <rect x="9" y="21" width="4" height="9" rx="1" fill="#651FFF" data-id="element-537" />
      <rect x="15" y="21" width="4" height="9" rx="1" fill="#651FFF" data-id="element-538" />
      {/* Right battlements */}
      <rect x="61" y="21" width="4" height="9" rx="1" fill="#651FFF" data-id="element-539" />
      <rect x="67" y="21" width="4" height="9" rx="1" fill="#651FFF" data-id="element-540" />
      <rect x="73" y="21" width="4" height="9" rx="1" fill="#651FFF" data-id="element-541" />
      {/* Main body */}
      <rect x="17" y="40" width="46" height="44" rx="4" fill="#7C4DFF" data-id="element-542" />
      {/* Main battlements */}
      <rect x="17" y="33" width="5" height="9" rx="1" fill="#651FFF" data-id="element-543" />
      <rect x="24" y="33" width="5" height="9" rx="1" fill="#651FFF" data-id="element-544" />
      <rect x="31" y="33" width="5" height="9" rx="1" fill="#651FFF" data-id="element-545" />
      <rect x="38" y="33" width="5" height="9" rx="1" fill="#651FFF" data-id="element-546" />
      <rect x="45" y="33" width="5" height="9" rx="1" fill="#651FFF" data-id="element-547" />
      <rect x="52" y="33" width="5" height="9" rx="1" fill="#651FFF" data-id="element-548" />
      {/* Windows */}
      <rect x="7" y="40" width="9" height="9" rx="2" fill="#EDE7F6" opacity="0.85" data-id="element-549" />
      <rect x="64" y="40" width="9" height="9" rx="2" fill="#EDE7F6" opacity="0.85" data-id="element-550" />
      <rect x="22" y="46" width="8" height="8" rx="2" fill="#EDE7F6" opacity="0.7" data-id="element-551" />
      <rect x="50" y="46" width="8" height="8" rx="2" fill="#EDE7F6" opacity="0.7" data-id="element-552" />
      {/* Door arch */}
      <rect x="32" y="62" width="16" height="22" rx="8" fill="rgba(0,0,0,0.28)" data-id="element-553" />
      {/* Flag pole */}
      <line x1="40" y1="2" x2="40" y2="22" stroke="#B388FF" strokeWidth="2" data-id="element-554" />
      {/* Flag */}
      <polygon points="40,2 56,8 40,14" fill="#FF4081" data-id="element-555" />
    </svg>;
}
function FortressSVG() {
  return <svg viewBox="0 0 88 84" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-556">
      {/* Shadow */}
      <ellipse cx="44" cy="80" rx="34" ry="5" fill="rgba(0,0,0,0.12)" data-id="element-557" />
      {/* Main wall */}
      <rect x="4" y="30" width="80" height="48" rx="5" fill="#C2185B" data-id="element-558" />
      {/* Battlements row */}
      <rect x="4" y="20" width="12" height="14" rx="2" fill="#E91E63" data-id="element-559" />
      <rect x="18" y="22" width="12" height="12" rx="2" fill="#E91E63" data-id="element-560" />
      <rect x="32" y="20" width="12" height="14" rx="2" fill="#E91E63" data-id="element-561" />
      <rect x="46" y="22" width="12" height="12" rx="2" fill="#E91E63" data-id="element-562" />
      <rect x="60" y="20" width="12" height="14" rx="2" fill="#E91E63" data-id="element-563" />
      <rect x="74" y="22" width="10" height="12" rx="2" fill="#E91E63" data-id="element-564" />
      {/* Stone texture lines */}
      <line x1="4" y1="48" x2="84" y2="48" stroke="rgba(0,0,0,0.12)" strokeWidth="1.5" data-id="element-565" />
      <line x1="4" y1="62" x2="84" y2="62" stroke="rgba(0,0,0,0.12)" strokeWidth="1.5" data-id="element-566" />
      <line x1="28" y1="30" x2="28" y2="78" stroke="rgba(0,0,0,0.08)" strokeWidth="1" data-id="element-567" />
      <line x1="56" y1="30" x2="56" y2="78" stroke="rgba(0,0,0,0.08)" strokeWidth="1" data-id="element-568" />
      {/* Windows */}
      <rect x="8" y="36" width="14" height="12" rx="3" fill="#FCE4EC" opacity="0.8" data-id="element-569" />
      <rect x="62" y="36" width="14" height="12" rx="3" fill="#FCE4EC" opacity="0.8" data-id="element-570" />
      {/* Gate arch */}
      <rect x="32" y="50" width="24" height="28" rx="12" fill="rgba(0,0,0,0.25)" data-id="element-571" />
      {/* Book icon on gate */}
      <rect x="37" y="54" width="14" height="10" rx="2" fill="#FCE4EC" opacity="0.7" data-id="element-572" />
      <line x1="44" y1="54" x2="44" y2="64" stroke="rgba(200,0,80,0.4)" strokeWidth="1" data-id="element-573" />
    </svg>;
}
function FoodCastleSVG() {
  return <svg viewBox="0 0 80 92" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-574">
      {/* Shadow */}
      <ellipse cx="40" cy="88" rx="30" ry="5" fill="rgba(0,0,0,0.12)" data-id="element-575" />
      {/* Round tower body */}
      <ellipse cx="40" cy="62" rx="34" ry="28" fill="#388E3C" data-id="element-576" />
      {/* Roof cone */}
      <polygon points="40,20 70,50 10,50" fill="#2E7D32" data-id="element-577" />
      {/* Roof highlight */}
      <polygon points="40,20 55,38 40,44" fill="#43A047" opacity="0.5" data-id="element-578" />
      {/* Apple on top */}
      <circle cx="40" cy="18" r="7" fill="#E53935" data-id="element-579" />
      <path d="M40 11 Q45 6 48 9" stroke="#2E7D32" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-580" />
      <ellipse cx="37" cy="16" rx="2" ry="3" fill="rgba(255,255,255,0.3)" transform="rotate(-20 37 16)" data-id="element-581" />
      {/* Windows */}
      <circle cx="28" cy="58" r="7" fill="#E8F5E9" opacity="0.8" data-id="element-582" />
      <circle cx="52" cy="58" r="7" fill="#E8F5E9" opacity="0.8" data-id="element-583" />
      {/* Door */}
      <rect x="32" y="68" width="16" height="20" rx="8" fill="rgba(0,0,0,0.22)" data-id="element-584" />
      {/* Side bushes */}
      <ellipse cx="10" cy="72" rx="9" ry="6" fill="#66BB6A" opacity="0.7" transform="rotate(-15 10 72)" data-id="element-585" />
      <ellipse cx="70" cy="72" rx="9" ry="6" fill="#66BB6A" opacity="0.7" transform="rotate(15 70 72)" data-id="element-586" />
    </svg>;
}
function BastionSVG() {
  return <svg viewBox="0 0 80 92" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-587">
      {/* Shadow */}
      <ellipse cx="40" cy="88" rx="28" ry="5" fill="rgba(0,0,0,0.12)" data-id="element-588" />
      {/* Main tower */}
      <rect x="20" y="28" width="40" height="58" rx="6" fill="#1565C0" data-id="element-589" />
      {/* Roof */}
      <polygon points="40,4 66,28 14,28" fill="#0D47A1" data-id="element-590" />
      {/* Roof highlight */}
      <polygon points="40,4 55,18 40,24" fill="#1976D2" opacity="0.5" data-id="element-591" />
      {/* Battlements */}
      <rect x="19" y="22" width="6" height="9" rx="1" fill="#1565C0" data-id="element-592" />
      <rect x="27" y="22" width="6" height="9" rx="1" fill="#1565C0" data-id="element-593" />
      <rect x="35" y="22" width="6" height="9" rx="1" fill="#1565C0" data-id="element-594" />
      <rect x="43" y="22" width="6" height="9" rx="1" fill="#1565C0" data-id="element-595" />
      <rect x="51" y="22" width="6" height="9" rx="1" fill="#1565C0" data-id="element-596" />
      {/* Windows */}
      <rect x="26" y="36" width="12" height="10" rx="5" fill="#E3F2FD" opacity="0.85" data-id="element-597" />
      <rect x="42" y="36" width="12" height="10" rx="5" fill="#E3F2FD" opacity="0.85" data-id="element-598" />
      <rect x="26" y="52" width="12" height="10" rx="5" fill="#E3F2FD" opacity="0.7" data-id="element-599" />
      <rect x="42" y="52" width="12" height="10" rx="5" fill="#E3F2FD" opacity="0.7" data-id="element-600" />
      {/* Door */}
      <rect x="30" y="68" width="20" height="18" rx="10" fill="rgba(0,0,0,0.25)" data-id="element-601" />
      {/* Speech bubble icon */}
      <rect x="48" y="10" width="22" height="14" rx="5" fill="white" opacity="0.9" data-id="element-602" />
      <polygon points="52,24 48,30 58,24" fill="white" opacity="0.9" data-id="element-603" />
      <circle cx="55" cy="17" r="1.5" fill="#1565C0" data-id="element-604" />
      <circle cx="59" cy="17" r="1.5" fill="#1565C0" data-id="element-605" />
      <circle cx="63" cy="17" r="1.5" fill="#1565C0" data-id="element-606" />
    </svg>;
}
const BUILDING_SVGS = [CastleSVG, FortressSVG, FoodCastleSVG, BastionSVG];
// ── Adventure Map Section ──────────────────────────────────────────────────
function AdventureMap({
  completedCount,
  openMission,
  meeloMsg,
  showMeelo,
  allDone
}: {
  completedCount: number;
  openMission: (id: number) => void;
  meeloMsg: string;
  showMeelo: boolean;
  allDone: boolean;
}) {
  const buildingPositions = [{
    cx: 130,
    cy: 90
  }, {
    cx: 390,
    cy: 230
  }, {
    cx: 130,
    cy: 400
  }, {
    cx: 390,
    cy: 570
  }];
  const PATH = 'M 130,90 C 260,90 260,230 390,230 C 520,230 520,400 130,400 C 0,400 0,570 390,570';
  const TOTAL_LEN = 840;
  const progressLen = Math.min(completedCount, 3) * (TOTAL_LEN / 3);
  return <section id="map-section" className="py-16 lg:py-20 relative overflow-hidden" style={{
    background: '#F6F1E8'
  }} data-id="element-607">
      {/* Parchment texture overlay */}
      <div className="absolute inset-0 pointer-events-none" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3CfeColorMatrix type='saturate' values='0'/%3E%3C/filter%3E%3Crect width='200' height='200' filter='url(%23n)' opacity='0.055'/%3E%3C/svg%3E")`,
      backgroundRepeat: 'repeat'
    }} data-id="element-608" />
      {/* Vignette */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 85% 85% at 50% 50%, transparent 55%, rgba(160,120,60,0.22) 100%)'
    }} data-id="element-609" />
      {/* Decorative border frame */}
      <div className="absolute inset-4 sm:inset-8 pointer-events-none rounded-2xl" style={{
      border: '2px solid rgba(139,105,20,0.22)',
      boxShadow: 'inset 0 0 50px rgba(139,105,20,0.07)'
    }} data-id="element-610" />
      {/* Corner ornaments */}
      {[{
      top: 12,
      left: 12
    }, {
      top: 12,
      right: 12
    }, {
      bottom: 12,
      left: 12
    }, {
      bottom: 12,
      right: 12
    }].map((pos, i) => <div key={i} className="absolute text-[#8B6914] text-xl pointer-events-none select-none" style={{
      ...pos,
      opacity: 0.35
    }} data-id="element-611">
          ✦
        </div>)}

      {/* ── MAP COMPLETION BRIGHTENING ── */}
      {allDone && <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 80% 70% at 50% 45%, rgba(255,220,100,0.22) 0%, transparent 70%)',
      animation: 'map-brighten 1200ms ease forwards'
    }} data-id="element-612" />}

      <div className="max-w-3xl mx-auto px-4 relative z-10" data-id="element-613">
        {/* ── HEADLINE ── */}
        <div className="text-center mb-10" data-id="element-614">
          <div className="inline-flex items-center gap-2 text-xs font-bold tracking-widest uppercase mb-3 px-4 py-1.5 rounded-full" style={{
          color: '#8B6914',
          background: 'rgba(139,105,20,0.10)',
          border: '1px solid rgba(139,105,20,0.20)'
        }} data-id="element-615">
            🗺️ Карта миссий
          </div>
          <h2 className="text-2xl md:text-3xl font-bold leading-tight" style={{
          color: '#3D2800'
        }} data-id="element-616">
            Карта Королевства Порядка
          </h2>
          <p className="text-sm mt-2 font-medium" style={{
          color: '#8B6914'
        }} data-id="element-617">
            4 дворца — 4 шага к полному контролю
          </p>
        </div>

        {/* ── DESKTOP MAP ── */}
        <div className="hidden sm:block relative mx-auto" style={{
        maxWidth: 520,
        height: 680
      }} data-id="element-618">
          {/* ── MAP SVG CANVAS ── */}
          <svg className="absolute inset-0 w-full h-full" viewBox="0 0 520 680" preserveAspectRatio="xMidYMid meet" style={{
          overflow: 'visible'
        }} data-id="element-619">
            <defs data-id="element-620">
              <filter id="map-glow" x="-50%" y="-50%" width="200%" height="200%" data-id="element-621">
                <feGaussianBlur stdDeviation="4" result="blur" data-id="element-622" />
                <feMerge data-id="element-623">
                  <feMergeNode in="blur" data-id="element-624" />
                  <feMergeNode in="SourceGraphic" data-id="element-625" />
                </feMerge>
              </filter>
              <filter id="fog-blur" x="-20%" y="-20%" width="140%" height="140%" data-id="element-626">
                <feGaussianBlur stdDeviation="3" data-id="element-627" />
              </filter>
            </defs>

            {/* ── GROUND PATCHES ── */}
            <ellipse cx="130" cy="118" rx="72" ry="24" fill="#E8D9B8" opacity="0.6" data-id="element-628" />
            <ellipse cx="390" cy="258" rx="72" ry="24" fill="#E8D9B8" opacity="0.55" data-id="element-629" />
            <ellipse cx="130" cy="428" rx="72" ry="24" fill="#E8D9B8" opacity="0.6" data-id="element-630" />
            <ellipse cx="390" cy="598" rx="72" ry="24" fill="#E8D9B8" opacity="0.55" data-id="element-631" />

            {/* ── DECORATIVE HILLS ── */}
            <ellipse cx="30" cy="340" rx="55" ry="28" fill="#C8B88A" opacity="0.35" data-id="element-632" />
            <ellipse cx="490" cy="160" rx="48" ry="22" fill="#C8B88A" opacity="0.30" data-id="element-633" />
            <ellipse cx="460" cy="480" rx="52" ry="24" fill="#C8B88A" opacity="0.32" data-id="element-634" />

            {/* ── SMALL LAKE / POND ── */}
            <ellipse cx="430" cy="450" rx="42" ry="20" fill="#A8C8E0" opacity="0.55" data-id="element-635" />
            <ellipse cx="430" cy="450" rx="36" ry="15" fill="#B8D8F0" opacity="0.45" data-id="element-636" />
            <ellipse cx="424" cy="445" rx="10" ry="4" fill="white" opacity="0.28" transform="rotate(-25 424 445)" data-id="element-637" />
            <text x="430" y="454" textAnchor="middle" fontSize="10" opacity="0.5" data-id="element-638">
              🦆
            </text>

            {/* ── TREES ── */}
            {/* Tree cluster top-left */}
            <g opacity="0.72" data-id="element-639">
              <ellipse cx="42" cy="162" rx="10" ry="3" fill="rgba(0,0,0,0.10)" data-id="element-640" />
              <rect x="39" y="148" width="5" height="16" fill="#8B6914" opacity="0.8" data-id="element-641" />
              <polygon points="42,128 56,148 28,148" fill="#5D8A3C" data-id="element-642" />
              <polygon points="42,120 54,138 30,138" fill="#6B9E47" data-id="element-643" />
            </g>
            {/* Tree right side */}
            <g opacity="0.65" data-id="element-644">
              <ellipse cx="478" cy="310" rx="10" ry="3" fill="rgba(0,0,0,0.10)" data-id="element-645" />
              <rect x="475" y="296" width="5" height="16" fill="#8B6914" opacity="0.8" data-id="element-646" />
              <polygon points="478,276 492,296 464,296" fill="#5D8A3C" data-id="element-647" />
              <polygon points="478,268 490,286 466,286" fill="#6B9E47" data-id="element-648" />
            </g>
            {/* Small bush bottom-left */}
            <g opacity="0.60" data-id="element-649">
              <ellipse cx="55" cy="518" rx="22" ry="12" fill="#6B9E47" data-id="element-650" />
              <ellipse cx="44" cy="514" rx="14" ry="10" fill="#7BAF52" data-id="element-651" />
              <ellipse cx="66" cy="514" rx="14" ry="10" fill="#7BAF52" data-id="element-652" />
            </g>
            {/* Small bush top-right */}
            <g opacity="0.55" data-id="element-653">
              <ellipse cx="468" cy="148" rx="18" ry="10" fill="#6B9E47" data-id="element-654" />
              <ellipse cx="458" cy="144" rx="12" ry="8" fill="#7BAF52" data-id="element-655" />
              <ellipse cx="478" cy="144" rx="12" ry="8" fill="#7BAF52" data-id="element-656" />
            </g>

            {/* ── COBBLESTONE PATH — shadow layer ── */}
            <path d={PATH} stroke="#C4A882" strokeWidth="22" fill="none" strokeLinecap="round" opacity="0.28" data-id="element-657" />
            {/* Cobblestone base */}
            <path d={PATH} stroke="#A0845C" strokeWidth="14" fill="none" strokeLinecap="round" strokeDasharray="10 5" opacity="0.50" data-id="element-658" />
            {/* Cobblestone inner */}
            <path d={PATH} stroke="#D4B896" strokeWidth="8" fill="none" strokeLinecap="round" strokeDasharray="7 8" opacity="0.55" data-id="element-659" />
            {/* Cobblestone highlight */}
            <path d={PATH} stroke="#F0E0C8" strokeWidth="3" fill="none" strokeLinecap="round" strokeDasharray="5 10" opacity="0.40" data-id="element-660" />

            {/* ── PROGRESS PATH (magical glow) ── */}
            <path d={PATH} stroke="#7C4DFF" strokeWidth="10" fill="none" strokeLinecap="round" opacity="0.70" style={{
            strokeDasharray: TOTAL_LEN,
            strokeDashoffset: TOTAL_LEN - progressLen,
            transition: 'stroke-dashoffset 800ms cubic-bezier(0.4,0,0.2,1)',
            filter: 'url(#map-glow)'
          }} data-id="element-661" />
            {/* Animated flowing light */}
            {completedCount < 4 && <path d={PATH} stroke="#B388FF" strokeWidth="5" fill="none" strokeLinecap="round" style={{
            strokeDasharray: '30 810',
            strokeDashoffset: TOTAL_LEN - progressLen - 15,
            animation: 'path-flow 1.8s linear infinite',
            opacity: 0.85
          }} data-id="element-662" />}

            {/* ── PATH SPARKLES ── */}
            {[{
            x: 260,
            y: 90,
            delay: '0s',
            size: 14
          }, {
            x: 390,
            y: 320,
            delay: '0.6s',
            size: 11
          }, {
            x: 260,
            y: 400,
            delay: '1.2s',
            size: 13
          }, {
            x: 260,
            y: 570,
            delay: '0.3s',
            size: 10
          }].map((s, i) => <text key={i} x={s.x} y={s.y} textAnchor="middle" fontSize={s.size} fill="#FFD700" filter="url(#map-glow)" style={{
            animation: `map-sparkle ${2.2 + i * 0.4}s ease-in-out infinite`,
            animationDelay: s.delay
          }} data-id="element-663">
                ✦
              </text>)}

            {/* ── COMPASS ── */}
            <g transform="translate(472, 636)" opacity="0.75" data-id="element-664">
              <circle cx="0" cy="0" r="22" fill="#F0E8D0" stroke="#8B6914" strokeWidth="1.5" data-id="element-665" />
              <circle cx="0" cy="0" r="18" fill="none" stroke="#8B6914" strokeWidth="0.5" opacity="0.5" data-id="element-666" />
              <text x="0" y="-10" textAnchor="middle" fontSize="7" fill="#8B6914" fontWeight="bold" data-id="element-667">
                N
              </text>
              <text x="0" y="15" textAnchor="middle" fontSize="7" fill="#8B6914" fontWeight="bold" data-id="element-668">
                S
              </text>
              <text x="13" y="3" textAnchor="middle" fontSize="7" fill="#8B6914" fontWeight="bold" data-id="element-669">
                E
              </text>
              <text x="-13" y="3" textAnchor="middle" fontSize="7" fill="#8B6914" fontWeight="bold" data-id="element-670">
                W
              </text>
              <polygon points="0,-14 2.5,-3 0,-6 -2.5,-3" fill="#C0392B" data-id="element-671" />
              <polygon points="0,14 2.5,3 0,6 -2.5,3" fill="#8B6914" opacity="0.7" data-id="element-672" />
              <circle cx="0" cy="0" r="2.5" fill="#8B6914" data-id="element-673" />
            </g>

            {/* ── DECORATIVE NATURE ICONS ── */}
            <text x="18" y="200" fontSize="16" opacity="0.45" style={{
            animation: 'map-float 4s ease-in-out infinite'
          }} data-id="element-674">
              🌿
            </text>
            <text x="490" y="390" fontSize="14" opacity="0.40" style={{
            animation: 'map-float 5s ease-in-out infinite',
            animationDelay: '1s'
          }} data-id="element-675">
              🍃
            </text>
            <text x="240" y="168" fontSize="12" opacity="0.35" style={{
            animation: 'map-sparkle 3s ease-in-out infinite',
            animationDelay: '0.5s'
          }} data-id="element-676">
              ⭐
            </text>
            <text x="270" y="490" fontSize="10" opacity="0.30" style={{
            animation: 'map-sparkle 4s ease-in-out infinite',
            animationDelay: '1.5s'
          }} data-id="element-677">
              ✨
            </text>
            <text x="60" y="460" fontSize="13" opacity="0.40" style={{
            animation: 'map-float 6s ease-in-out infinite',
            animationDelay: '2s'
          }} data-id="element-678">
              🌸
            </text>
          </svg>

          {/* ── BUILDING NODES ── */}
          {BUILDINGS.map((b, i) => {
          const {
            cx,
            cy
          } = buildingPositions[i];
          const status = i < completedCount ? 'completed' : i === completedCount ? 'active' : 'locked';
          const BuildingSVG = BUILDING_SVGS[i];
          const nodeW = 80;
          const nodeH = 88;
          return <div key={b.id} className="absolute flex flex-col items-center" style={{
            left: cx - nodeW / 2 - 30,
            top: cy - nodeH / 2 - 10,
            width: nodeW + 60,
            zIndex: status === 'active' ? 20 : 10
          }} data-id="element-679">
                <button onClick={() => openMission(b.id)} disabled={status === 'locked'} className="relative flex flex-col items-center group" style={{
              cursor: status === 'locked' ? 'not-allowed' : 'pointer'
            }} data-id="element-680">
                  {/* Active glow ring */}
                  {status === 'active' && <div className="absolute rounded-full pointer-events-none" style={{
                inset: -12,
                background: `radial-gradient(circle, ${b.color}28 0%, transparent 70%)`,
                animation: 'node-pulse 2s ease infinite'
              }} data-id="element-681" />}

                  {/* Building illustration */}
                  <div className="relative transition-transform duration-300" style={{
                width: nodeW,
                height: nodeH,
                filter: status === 'locked' ? 'grayscale(0.85) opacity(0.5)' : status === 'active' ? `drop-shadow(0 8px 20px ${b.color}55)` : `drop-shadow(0 4px 10px ${b.color}30)`,
                transform: status === 'active' ? 'scale(1.10)' : 'scale(1)',
                animation: status === 'active' ? 'building-active-glow 2.5s ease-in-out infinite' : 'none'
              }} data-id="element-682">
                    <BuildingSVG data-id="element-683" />

                    {/* Completed badge */}
                    {status === 'completed' && <div className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-green-500 flex items-center justify-center shadow-md border-2 border-white" data-id="element-684">
                        <Check size={13} color="white" strokeWidth={3} data-id="element-685" />
                      </div>}

                    {/* Meelo on active */}
                    {status === 'active' && <div className="absolute -top-4 -right-4 w-10 h-10 rounded-full bg-white border-2 overflow-hidden shadow-lg" style={{
                  borderColor: b.color,
                  animation: 'meelo-bounce 2s ease-in-out infinite'
                }} data-id="element-686">
                        <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-0.5" data-id="element-687" />
                      </div>}
                  </div>

                  {/* Fog overlay for locked */}
                  {status === 'locked' && <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{
                background: 'rgba(246,241,232,0.55)',
                backdropFilter: 'blur(1.5px)',
                animation: 'fog-drift 4s ease-in-out infinite'
              }} data-id="element-688" />}

                  {/* Lock icon for locked */}
                  {status === 'locked' && <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-6 h-6 rounded-full bg-white/80 flex items-center justify-center shadow-sm border border-gray-200" style={{
                animation: 'meelo-bounce 3s ease-in-out infinite'
              }} data-id="element-689">
                      <Lock size={11} color="#9CA3AF" data-id="element-690" />
                    </div>}

                  {/* Building name */}
                  <div className="mt-2 text-center" style={{
                width: nodeW + 60
              }} data-id="element-691">
                    <p className="text-xs font-bold leading-tight" style={{
                  color: status === 'locked' ? '#B8A880' : '#3D2800',
                  opacity: status === 'locked' ? 0.6 : 1
                }} data-id="element-692">
                      {b.name}
                    </p>
                    {status === 'active' && <p className="text-[10px] font-bold mt-0.5 animate-pulse" style={{
                  color: b.color
                }} data-id="element-693">
                        ▶ Нажми
                      </p>}
                    {status === 'completed' && <p className="text-[10px] text-green-600 font-semibold mt-0.5" data-id="element-694">
                        ✓ Выполнено
                      </p>}
                  </div>
                </button>
              </div>;
        })}
        </div>

        {/* ── MOBILE MAP — vertical parchment scroll ── */}
        <div className="sm:hidden flex flex-col items-center gap-0 relative" data-id="element-695">
          {/* Vertical cobblestone path */}
          <div className="absolute left-1/2 top-12 bottom-12 -translate-x-1/2 pointer-events-none" style={{
          width: 14
        }} data-id="element-696">
            {/* Shadow */}
            <div className="absolute inset-0 rounded-full" style={{
            background: '#C4A882',
            opacity: 0.3,
            filter: 'blur(3px)'
          }} data-id="element-697" />
            {/* Cobblestone base */}
            <div className="absolute inset-0 rounded-full" style={{
            background: 'repeating-linear-gradient(180deg, #A0845C 0, #A0845C 10px, #D4B896 10px, #D4B896 16px)',
            opacity: 0.55
          }} data-id="element-698" />
          </div>
          {/* Progress overlay */}
          <div className="absolute left-1/2 top-12 w-3.5 -translate-x-1/2 rounded-full pointer-events-none transition-all duration-700" style={{
          height: `${completedCount / 4 * 100}%`,
          background: 'linear-gradient(180deg, #7C4DFF, #B388FF)',
          opacity: 0.75,
          boxShadow: '0 0 8px rgba(124,77,255,0.4)'
        }} data-id="element-699" />

          {BUILDINGS.map((b, i) => {
          const status = i < completedCount ? 'completed' : i === completedCount ? 'active' : 'locked';
          const BuildingSVG = BUILDING_SVGS[i];
          return <div key={b.id} className="relative z-10 flex flex-col items-center py-6" data-id="element-700">
                <button onClick={() => openMission(b.id)} disabled={status === 'locked'} className="flex flex-col items-center" data-id="element-701">
                  <div className="relative mb-2" style={{
                width: 72,
                height: 80,
                filter: status === 'locked' ? 'grayscale(0.85) opacity(0.5)' : status === 'active' ? `drop-shadow(0 6px 14px ${b.color}55)` : `drop-shadow(0 3px 8px ${b.color}30)`,
                transform: status === 'active' ? 'scale(1.1)' : 'scale(1)',
                transition: 'transform 300ms ease',
                animation: status === 'active' ? 'building-active-glow 2.5s ease-in-out infinite' : 'none'
              }} data-id="element-702">
                    <BuildingSVG data-id="element-703" />
                    {status === 'completed' && <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-green-500 flex items-center justify-center shadow-md border-2 border-white" data-id="element-704">
                        <Check size={11} color="white" strokeWidth={3} data-id="element-705" />
                      </div>}
                    {status === 'active' && <div className="absolute -top-3 -right-3 w-9 h-9 rounded-full bg-white border-2 overflow-hidden shadow-lg" style={{
                  borderColor: b.color,
                  animation: 'meelo-bounce 2s ease-in-out infinite'
                }} data-id="element-706">
                        <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-0.5" data-id="element-707" />
                      </div>}
                    {status === 'locked' && <>
                        <div className="absolute inset-0 rounded-xl pointer-events-none" style={{
                    background: 'rgba(246,241,232,0.50)',
                    backdropFilter: 'blur(1.5px)',
                    animation: 'fog-drift 4s ease-in-out infinite'
                  }} data-id="element-708" />
                        <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-5 h-5 rounded-full bg-white/80 flex items-center justify-center shadow-sm border border-gray-200" data-id="element-709">
                          <Lock size={9} color="#9CA3AF" data-id="element-710" />
                        </div>
                      </>}
                  </div>
                  <p className="text-sm font-bold text-center max-w-[160px] leading-tight" style={{
                color: status === 'locked' ? '#B8A880' : '#3D2800',
                opacity: status === 'locked' ? 0.6 : 1
              }} data-id="element-711">
                    {b.name}
                  </p>
                  {status === 'active' && <p className="text-xs font-bold mt-1 animate-pulse" style={{
                color: b.color
              }} data-id="element-712">
                      ▶ Нажми
                    </p>}
                  {status === 'completed' && <p className="text-xs text-green-600 font-semibold mt-1" data-id="element-713">
                      ✓ Выполнено
                    </p>}
                </button>
              </div>;
        })}
        </div>

        {/* ── MEELO MAP MESSAGE ── */}
        <div className="flex items-center justify-center gap-3 mt-10 transition-opacity duration-500" style={{
        opacity: showMeelo ? 1 : 0.4
      }} data-id="element-714">
          <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0" style={{
          background: '#EDE7F6',
          border: '1.5px solid rgba(124,77,255,0.25)',
          animation: 'meelo-bounce 2.4s ease-in-out infinite'
        }} data-id="element-715">
            <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-1" data-id="element-716" />
          </div>
          <div className="rounded-2xl rounded-tl-sm px-4 py-2.5 shadow-sm max-w-xs" style={{
          background: 'rgba(255,255,255,0.80)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(139,105,20,0.18)'
        }} data-id="element-717">
            <p className="text-sm leading-relaxed" style={{
            color: '#5D3A00'
          }} data-id="element-718">
              {meeloMsg}
            </p>
          </div>
        </div>
      </div>
    </section>;
}
// ── Main Page ──────────────────────────────────────────────────────────────
export function MissionPage() {
  const [completed, setCompleted] = useState<Set<number>>(new Set());
  const [activeMission, setActiveMission] = useState<number | null>(null);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMsg, setToastMsg] = useState('');
  const [meeloMsg, setMeeloMsg] = useState(MEELO_MSGS[0]);
  const [showMeelo, setShowMeelo] = useState(true);
  const [showConfetti, setShowConfetti] = useState(false);
  const [showCompletionOverlay, setShowCompletionOverlay] = useState(false);
  const toastTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const meeloTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const confettiTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const completedCount = completed.size;
  const progress = completedCount * 25;
  const chaos = CHAOS[completedCount];
  const energy = ENERGY[completedCount];
  const allDone = completedCount === 4;
  // Show completion overlay with a short delay after finishing
  useEffect(() => {
    if (allDone) {
      const t = setTimeout(() => setShowCompletionOverlay(true), 1200);
      return () => clearTimeout(t);
    }
  }, [allDone]);
  const showMeeloMsg = useCallback((msg: string, duration = 5000) => {
    setMeeloMsg(msg);
    setShowMeelo(true);
    if (meeloTimer.current) clearTimeout(meeloTimer.current);
    meeloTimer.current = setTimeout(() => setShowMeelo(false), duration);
  }, []);
  const handleComplete = useCallback((id: number) => {
    if (completed.has(id)) return;
    setCompleted(prev => new Set([...prev, id]));
    setActiveMission(null);
    playChime();
    setShowConfetti(true);
    if (confettiTimer.current) clearTimeout(confettiTimer.current);
    confettiTimer.current = setTimeout(() => setShowConfetti(false), 2000);
    const toasts = ['Хаос ↓ до 70%', 'Хаос ↓ до 45%', 'Хаос ↓ до 20%', '🏆 Хаос = 0%!'];
    setToastMsg(`✓ Миссия ${id} выполнена — ${toasts[id - 1]}`);
    setToastVisible(true);
    if (toastTimer.current) clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToastVisible(false), 3500);
    showMeeloMsg(MEELO_MSGS[id], 6000);
  }, [completed, showMeeloMsg]);
  const openMission = (id: number) => {
    if (id > completedCount + 1) return;
    setActiveMission(id);
  };
  useEffect(() => {
    return () => {
      if (toastTimer.current) clearTimeout(toastTimer.current);
      if (meeloTimer.current) clearTimeout(meeloTimer.current);
      if (confettiTimer.current) clearTimeout(confettiTimer.current);
    };
  }, []);
  const activeBuilding = activeMission !== null ? BUILDINGS[activeMission - 1] : null;
  return <div className="min-h-screen font-sans text-gray-900 bg-[#FAFAFA]" data-id="element-719">
      <MissionNavbar data-id="element-720" />
      <ProgressPill progress={progress} data-id="element-721" />
      <Confetti active={showConfetti} data-id="element-722" />

      {/* ── HERO ─────────────────────────────────────────────────────── */}
      <section className="relative overflow-hidden" style={{
      background: 'linear-gradient(180deg, #E8D4A8 0%, #F0E4C8 28%, #F6EDD8 58%, #F6F1E8 100%)',
      minHeight: '100vh',
      paddingTop: 'clamp(7rem, 12vw, 10rem)',
      paddingBottom: 'clamp(14rem, 22vw, 20rem)'
    }} data-id="element-723">
        {/* ── PARCHMENT TEXTURE ── */}
        <div className="absolute inset-0 pointer-events-none" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3CfeColorMatrix type='saturate' values='0'/%3E%3C/filter%3E%3Crect width='200' height='200' filter='url(%23n)' opacity='0.045'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat'
      }} data-id="element-724" />

        {/* ── VIGNETTE ── */}
        <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse 88% 88% at 50% 50%, transparent 52%, rgba(140,100,40,0.22) 100%)'
      }} data-id="element-725" />

        {/* ── DECORATIVE BORDER FRAME ── */}
        <div className="absolute inset-4 sm:inset-8 pointer-events-none rounded-2xl" style={{
        border: '2px solid rgba(139,105,20,0.20)',
        boxShadow: 'inset 0 0 60px rgba(139,105,20,0.06)'
      }} data-id="element-726" />

        {/* ── CORNER ORNAMENTS ── */}
        {[{
        top: 14,
        left: 14
      }, {
        top: 14,
        right: 14
      }, {
        bottom: 14,
        left: 14
      }, {
        bottom: 14,
        right: 14
      }].map((pos, i) => <div key={i} className="absolute text-xl pointer-events-none select-none" style={{
        ...pos,
        color: '#8B6914',
        opacity: 0.32
      }} data-id="element-727">
            ✦
          </div>)}

        {/* ── SKY SPARKLES ── */}
        {['12%', '18%', '28%', '8%', '35%'].map((top, i) => <div key={i} className="absolute pointer-events-none select-none" style={{
        top,
        left: `${[15, 72, 42, 88, 55][i]}%`,
        fontSize: [10, 8, 12, 9, 7][i],
        color: '#C4A040',
        opacity: 0.38,
        animation: `chaos-float-${i % 4 + 1} ${4 + i}s ease-in-out infinite`,
        animationDelay: `${i * 0.7}s`
      }} data-id="element-728">
            ✦
          </div>)}

        {/* ── WARM CLOUDS ── */}
        <div className="absolute pointer-events-none" style={{
        top: '10%',
        left: '3%',
        animation: 'cloud-drift-1 28s ease-in-out infinite'
      }} data-id="element-729">
          <div className="relative" style={{
          width: 160,
          height: 48
        }} data-id="element-730">
            <div className="absolute inset-0 rounded-full" style={{
            background: 'rgba(255,245,220,0.65)',
            filter: 'blur(12px)'
          }} data-id="element-731" />
            <div className="absolute rounded-full" style={{
            width: 100,
            height: 52,
            top: -10,
            left: 30,
            background: 'rgba(255,240,210,0.55)',
            filter: 'blur(11px)'
          }} data-id="element-732" />
            <div className="absolute rounded-full" style={{
            width: 70,
            height: 38,
            top: -6,
            left: 80,
            background: 'rgba(255,235,200,0.50)',
            filter: 'blur(9px)'
          }} data-id="element-733" />
          </div>
        </div>
        <div className="absolute pointer-events-none" style={{
        top: '8%',
        right: '5%',
        animation: 'cloud-drift-2 34s ease-in-out infinite'
      }} data-id="element-734">
          <div className="relative" style={{
          width: 130,
          height: 40
        }} data-id="element-735">
            <div className="absolute inset-0 rounded-full" style={{
            background: 'rgba(255,245,220,0.58)',
            filter: 'blur(10px)'
          }} data-id="element-736" />
            <div className="absolute rounded-full" style={{
            width: 80,
            height: 44,
            top: -8,
            left: 25,
            background: 'rgba(255,240,210,0.50)',
            filter: 'blur(10px)'
          }} data-id="element-737" />
          </div>
        </div>
        <div className="absolute pointer-events-none" style={{
        top: '20%',
        left: '38%',
        animation: 'cloud-drift-3 22s ease-in-out infinite'
      }} data-id="element-738">
          <div className="relative" style={{
          width: 90,
          height: 30
        }} data-id="element-739">
            <div className="absolute inset-0 rounded-full" style={{
            background: 'rgba(255,245,220,0.45)',
            filter: 'blur(9px)'
          }} data-id="element-740" />
            <div className="absolute rounded-full" style={{
            width: 55,
            height: 32,
            top: -6,
            left: 18,
            background: 'rgba(255,240,210,0.40)',
            filter: 'blur(8px)'
          }} data-id="element-741" />
          </div>
        </div>
        <div className="absolute pointer-events-none" style={{
        top: '16%',
        right: '22%',
        animation: 'cloud-drift-1 40s ease-in-out infinite',
        animationDelay: '5s'
      }} data-id="element-742">
          <div className="w-20 h-7 rounded-full pointer-events-none" style={{
          background: 'rgba(255,245,220,0.38)',
          filter: 'blur(7px)'
        }} data-id="element-743" />
        </div>

        {/* ── SVG ILLUSTRATED LANDSCAPE ── */}
        <svg viewBox="0 0 1200 300" preserveAspectRatio="xMidYMax meet" className="absolute bottom-0 left-0 w-full pointer-events-none" style={{
        zIndex: 1
      }} data-id="element-744">
          <defs data-id="element-745">
            <filter id="hero-glow" x="-50%" y="-50%" width="200%" height="200%" data-id="element-746">
              <feGaussianBlur stdDeviation="5" result="blur" data-id="element-747" />
              <feMerge data-id="element-748">
                <feMergeNode in="blur" data-id="element-749" />
                <feMergeNode in="SourceGraphic" data-id="element-750" />
              </feMerge>
            </filter>
            <filter id="path-glow" x="-50%" y="-50%" width="200%" height="200%" data-id="element-751">
              <feGaussianBlur stdDeviation="4" result="blur" data-id="element-752" />
              <feMerge data-id="element-753">
                <feMergeNode in="blur" data-id="element-754" />
                <feMergeNode in="SourceGraphic" data-id="element-755" />
              </feMerge>
            </filter>
          </defs>

          {/* Far background hills — pale parchment */}
          <ellipse cx="180" cy="300" rx="300" ry="90" fill="#D4C4A0" opacity="0.50" data-id="element-756" />
          <ellipse cx="650" cy="300" rx="420" ry="80" fill="#DDD0A8" opacity="0.45" data-id="element-757" />
          <ellipse cx="1080" cy="300" rx="300" ry="88" fill="#D4C4A0" opacity="0.50" data-id="element-758" />

          {/* ── BUILDING SILHOUETTES ── */}
          {/* Palace — far left */}
          <g opacity="0.50" fill="#8B7040" data-id="element-759">
            <rect x="148" y="198" width="9" height="32" data-id="element-760" />
            <rect x="185" y="198" width="9" height="32" data-id="element-761" />
            <rect x="154" y="208" width="40" height="22" data-id="element-762" />
            <rect x="146" y="192" width="4" height="8" data-id="element-763" />
            <rect x="152" y="192" width="4" height="8" data-id="element-764" />
            <rect x="185" y="192" width="4" height="8" data-id="element-765" />
            <rect x="191" y="192" width="4" height="8" data-id="element-766" />
            <line x1="171" y1="182" x2="171" y2="198" stroke="#8B7040" strokeWidth="1.5" data-id="element-767" />
            <polygon points="171,182 177,192 165,192" fill="#A08050" data-id="element-768" />
          </g>
          {/* Fortress — center-left */}
          <g opacity="0.46" fill="#9A7050" data-id="element-769">
            <rect x="368" y="205" width="82" height="25" data-id="element-770" />
            <rect x="366" y="196" width="11" height="12" data-id="element-771" />
            <rect x="379" y="198" width="11" height="10" data-id="element-772" />
            <rect x="392" y="196" width="11" height="12" data-id="element-773" />
            <rect x="405" y="198" width="11" height="10" data-id="element-774" />
            <rect x="418" y="196" width="14" height="12" data-id="element-775" />
          </g>
          {/* Food Castle — center-right */}
          <g opacity="0.48" data-id="element-776">
            <ellipse cx="755" cy="218" rx="36" ry="28" fill="#7A9050" data-id="element-777" />
            <polygon points="755,188 782,218 728,218" fill="#6A8040" data-id="element-778" />
            <circle cx="755" cy="190" r="5.5" fill="#B06040" opacity="0.82" data-id="element-779" />
            <path d="M755 184 Q759 180 762 182" stroke="#6A8040" strokeWidth="1.5" fill="none" strokeLinecap="round" data-id="element-780" />
          </g>
          {/* Bastion — right */}
          <g opacity="0.46" fill="#607090" data-id="element-781">
            <rect x="962" y="202" width="78" height="28" rx="7" data-id="element-782" />
            <ellipse cx="1001" cy="202" rx="40" ry="13" data-id="element-783" />
            <rect x="978" y="210" width="12" height="10" rx="3" fill="#E8DCC8" opacity="0.5" data-id="element-784" />
            <rect x="1011" y="210" width="12" height="10" rx="3" fill="#E8DCC8" opacity="0.5" data-id="element-785" />
          </g>

          {/* ── COBBLESTONE PATH ── */}
          {/* Shadow */}
          <path d="M 600,300 C 575,270 530,248 470,232 C 410,216 350,218 290,212 C 230,206 200,204 170,206" stroke="#C4A882" strokeWidth="18" fill="none" strokeLinecap="round" opacity="0.22" data-id="element-786" />
          {/* Base cobblestone */}
          <path d="M 600,300 C 575,270 530,248 470,232 C 410,216 350,218 290,212 C 230,206 200,204 170,206" stroke="#A0845C" strokeWidth="12" fill="none" strokeLinecap="round" strokeDasharray="10 5" opacity="0.48" data-id="element-787" />
          {/* Inner */}
          <path d="M 600,300 C 575,270 530,248 470,232 C 410,216 350,218 290,212 C 230,206 200,204 170,206" stroke="#D4B896" strokeWidth="6" fill="none" strokeLinecap="round" strokeDasharray="7 8" opacity="0.50" data-id="element-788" />
          {/* Highlight */}
          <path d="M 600,300 C 575,270 530,248 470,232 C 410,216 350,218 290,212 C 230,206 200,204 170,206" stroke="#F0E0C8" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeDasharray="5 10" opacity="0.38" data-id="element-789" />
          {/* Golden glow */}
          <path d="M 600,300 C 575,270 530,248 470,232 C 410,216 350,218 290,212 C 230,206 200,204 170,206" stroke="#FFD700" strokeWidth="10" fill="none" strokeLinecap="round" opacity="0.12" filter="url(#path-glow)" data-id="element-790" />
          {/* Sparkle dots */}
          <circle cx="470" cy="232" r="3" fill="#C4A040" opacity="0.72" filter="url(#hero-glow)" data-id="element-791" />
          <circle cx="350" cy="216" r="2.5" fill="#D4B050" opacity="0.62" filter="url(#hero-glow)" data-id="element-792" />
          <circle cx="240" cy="208" r="2" fill="#C4A040" opacity="0.55" filter="url(#hero-glow)" data-id="element-793" />

          {/* ── TREES ── */}
          <g opacity="0.55" data-id="element-794">
            <ellipse cx="80" cy="278" rx="10" ry="3" fill="rgba(0,0,0,0.08)" data-id="element-795" />
            <rect x="77" y="264" width="5" height="16" fill="#8B6914" opacity="0.7" data-id="element-796" />
            <polygon points="80,244 94,264 66,264" fill="#5D7030" data-id="element-797" />
            <polygon points="80,236 92,254 68,254" fill="#6B8038" data-id="element-798" />
          </g>
          <g opacity="0.50" data-id="element-799">
            <ellipse cx="1120" cy="278" rx="10" ry="3" fill="rgba(0,0,0,0.08)" data-id="element-800" />
            <rect x="1117" y="264" width="5" height="16" fill="#8B6914" opacity="0.7" data-id="element-801" />
            <polygon points="1120,244 1134,264 1106,264" fill="#5D7030" data-id="element-802" />
            <polygon points="1120,236 1132,254 1108,254" fill="#6B8038" data-id="element-803" />
          </g>
          {/* Bushes */}
          <g opacity="0.48" data-id="element-804">
            <ellipse cx="320" cy="290" rx="22" ry="10" fill="#6B8038" data-id="element-805" />
            <ellipse cx="308" cy="286" rx="14" ry="9" fill="#7B9042" data-id="element-806" />
            <ellipse cx="332" cy="286" rx="14" ry="9" fill="#7B9042" data-id="element-807" />
          </g>
          <g opacity="0.45" data-id="element-808">
            <ellipse cx="880" cy="290" rx="20" ry="9" fill="#6B8038" data-id="element-809" />
            <ellipse cx="869" cy="286" rx="13" ry="8" fill="#7B9042" data-id="element-810" />
            <ellipse cx="891" cy="286" rx="13" ry="8" fill="#7B9042" data-id="element-811" />
          </g>

          {/* Middle hills */}
          <ellipse cx="50" cy="300" rx="260" ry="72" fill="#C8B888" opacity="0.62" data-id="element-812" />
          <ellipse cx="1150" cy="300" rx="260" ry="72" fill="#C8B888" opacity="0.62" data-id="element-813" />
          <ellipse cx="600" cy="300" rx="220" ry="58" fill="#D4C898" opacity="0.52" data-id="element-814" />

          {/* Foreground hills */}
          <ellipse cx="200" cy="300" rx="380" ry="68" fill="#B8A870" opacity="0.75" data-id="element-815" />
          <ellipse cx="1000" cy="300" rx="380" ry="68" fill="#B8A870" opacity="0.75" data-id="element-816" />
          <ellipse cx="600" cy="300" rx="520" ry="55" fill="#C4B880" opacity="0.68" data-id="element-817" />

          {/* Grass tufts */}
          <ellipse cx="80" cy="300" rx="60" ry="16" fill="#A89860" opacity="0.55" data-id="element-818" />
          <ellipse cx="1120" cy="300" rx="60" ry="16" fill="#A89860" opacity="0.55" data-id="element-819" />
          <ellipse cx="380" cy="300" rx="45" ry="13" fill="#A89860" opacity="0.45" data-id="element-820" />
          <ellipse cx="820" cy="300" rx="45" ry="13" fill="#A89860" opacity="0.45" data-id="element-821" />
        </svg>

        {/* ── CONTENT ── */}
        <div className="max-w-2xl mx-auto px-4 text-center relative" style={{
        zIndex: 10
      }} data-id="element-822">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full mb-6" style={{
          color: '#8B6914',
          background: 'rgba(139,105,20,0.12)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(139,105,20,0.28)'
        }} data-id="element-823">
            🗺️ Интерактивное приключение
          </div>

          {/* Headline */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-[1.1] tracking-tight mb-4" style={{
          color: '#3D2800',
          textShadow: '0 2px 16px rgba(139,105,20,0.15)'
        }} data-id="element-824">
            Добро пожаловать в{' '}
            <span style={{
            color: '#7C4DFF',
            textShadow: '0 0 24px rgba(124,77,255,0.20)'
          }} data-id="element-825">
              Королевство Детского Сада
            </span>
          </h1>

          {/* Subtitle */}
          <p className="text-base sm:text-lg leading-relaxed mb-8 max-w-lg mx-auto font-medium" style={{
          color: '#5D3A00',
          opacity: 0.85
        }} data-id="element-826">
            Когда-то здесь царил порядок… Но операционный хаос захватил дворцы.{' '}
            <span style={{
            color: '#3D2800',
            fontWeight: 700,
            opacity: 1
          }} data-id="element-827">
              Поможете вернуть контроль?
            </span>
          </p>

          {/* Chaos / Energy indicators */}
          <div className="flex items-center justify-center gap-3 mb-8" data-id="element-828">
            <div className="flex items-center gap-2.5 rounded-2xl px-4 py-2.5 transition-all duration-700" style={{
            background: 'rgba(255,255,255,0.55)',
            backdropFilter: 'blur(12px)',
            border: '1px solid rgba(139,105,20,0.22)'
          }} data-id="element-829">
              <span className="text-2xl leading-none" style={{
              animation: 'meelo-bounce 2.8s ease-in-out infinite'
            }} data-id="element-830">
                ⛈️
              </span>
              <div className="text-left" data-id="element-831">
                <p className="text-[9px] font-bold uppercase tracking-widest leading-none mb-0.5" style={{
                color: '#8B6914'
              }} data-id="element-832">
                  Хаос
                </p>
                <p className="text-xl font-bold font-mono leading-none transition-all duration-700" style={{
                color: '#3D2800'
              }} data-id="element-833">
                  {chaos}%
                </p>
              </div>
            </div>

            <div className="w-px h-8" style={{
            background: 'rgba(139,105,20,0.20)'
          }} data-id="element-834" />

            <div className="flex items-center gap-2.5 rounded-2xl px-4 py-2.5 transition-all duration-700" style={{
            background: 'rgba(255,255,255,0.55)',
            backdropFilter: 'blur(12px)',
            border: '1px solid rgba(139,105,20,0.22)'
          }} data-id="element-835">
              <span className="text-2xl leading-none" style={{
              animation: 'chaos-float-1 3.2s ease-in-out infinite'
            }} data-id="element-836">
                💎
              </span>
              <div className="text-left" data-id="element-837">
                <p className="text-[9px] font-bold uppercase tracking-widest leading-none mb-0.5" style={{
                color: '#8B6914'
              }} data-id="element-838">
                  Энергия
                </p>
                <p className="text-xl font-bold font-mono leading-none transition-all duration-700" style={{
                color: '#3D2800'
              }} data-id="element-839">
                  {energy}%
                </p>
              </div>
            </div>
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3" data-id="element-840">
            <button onClick={() => document.getElementById('map-section')?.scrollIntoView({
            behavior: 'smooth'
          })} className="inline-flex items-center justify-center gap-2 px-10 py-4 rounded-full font-bold text-lg transition-all active:scale-95" style={{
            background: 'linear-gradient(135deg, #FFD700 0%, #E8A800 100%)',
            color: '#3D1A00',
            boxShadow: '0 0 32px rgba(200,160,0,0.45), 0 4px 16px rgba(0,0,0,0.12)'
          }} data-id="element-841">
              🗺️ Отправиться в путешествие
            </button>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 rounded-full font-medium text-lg transition-all" style={{
            border: '2px solid rgba(139,105,20,0.35)',
            color: '#5D3A00',
            background: 'rgba(255,255,255,0.40)',
            backdropFilter: 'blur(8px)'
          }} data-id="element-842">
              Хочу демо сразу
            </a>
          </div>
        </div>

        {/* ── MEELO CHARACTER ── */}
        <div className="absolute flex flex-col items-center" style={{
        bottom: '14%',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 15,
        animation: 'fadeInUp 1.2s ease forwards'
      }} data-id="element-843">
          {/* Glow ring */}
          <div className="absolute rounded-full pointer-events-none" style={{
          width: 100,
          height: 100,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          background: 'radial-gradient(circle, rgba(255,215,0,0.22) 0%, transparent 70%)',
          animation: 'node-pulse 2.8s ease-in-out infinite'
        }} data-id="element-844" />
          {/* Avatar */}
          <div className="w-20 h-20 rounded-full overflow-hidden shadow-2xl" style={{
          background: 'rgba(255,255,255,0.95)',
          border: '3px solid rgba(255,215,0,0.50)',
          animation: 'meelo-bounce 2.4s ease-in-out infinite',
          boxShadow: '0 6px 28px rgba(139,105,20,0.25), 0 0 0 6px rgba(255,215,0,0.10)'
        }} data-id="element-845">
            <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-1.5" data-id="element-846" />
          </div>
          {/* Speech bubble */}
          <div className="mt-2 rounded-2xl rounded-b-sm px-4 py-2.5 max-w-[220px] text-center" style={{
          background: 'rgba(255,255,255,0.88)',
          backdropFilter: 'blur(16px)',
          border: '1.5px solid rgba(139,105,20,0.22)',
          boxShadow: '0 8px 28px rgba(139,105,20,0.14)'
        }} data-id="element-847">
            <p className="text-xs font-semibold leading-relaxed" style={{
            color: '#5D3A00'
          }} data-id="element-848">
              Привет! Я Meelo. Давайте спасём ваш сад вместе. 💜
            </p>
          </div>
        </div>
      </section>

      {/* ── ADVENTURE MAP ────────────────────────────────────────────── */}
      <AdventureMap completedCount={completedCount} openMission={openMission} meeloMsg={meeloMsg} showMeelo={showMeelo} allDone={allDone} data-id="element-849" />

      {/* ── COMPLETION OVERLAY ───────────────────────────────────────── */}
      {showCompletionOverlay && <div className="fixed inset-0 flex items-center justify-center px-4" style={{
      zIndex: 150,
      background: '#F6F1E8',
      animation: 'completion-fade-in 700ms cubic-bezier(0.16,1,0.3,1) forwards'
    }} data-id="element-850">
          {/* Parchment texture */}
          <div className="absolute inset-0 pointer-events-none" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3CfeColorMatrix type='saturate' values='0'/%3E%3C/filter%3E%3Crect width='200' height='200' filter='url(%23n)' opacity='0.045'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat'
      }} data-id="element-851" />

          {/* Sunlight rays */}
          <div className="absolute pointer-events-none" style={{
        top: '-10%',
        left: '50%',
        width: '140%',
        maxWidth: 900,
        aspectRatio: '1',
        animation: 'sunray-rotate 60s linear infinite'
      }} data-id="element-852">
            <svg viewBox="0 0 800 800" fill="none" className="w-full h-full" data-id="element-853">
              {Array.from({
            length: 18
          }).map((_, i) => <line key={i} x1="400" y1="400" x2={400 + Math.cos(i / 18 * Math.PI * 2) * 600} y2={400 + Math.sin(i / 18 * Math.PI * 2) * 600} stroke="rgba(255,210,80,0.07)" strokeWidth="55" data-id="element-854" />)}
            </svg>
          </div>

          {/* Warm radial glow */}
          <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse 70% 65% at 50% 42%, rgba(255,220,120,0.28) 0%, transparent 70%)'
      }} data-id="element-855" />

          {/* Vignette */}
          <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse 88% 88% at 50% 50%, transparent 55%, rgba(140,100,40,0.18) 100%)'
      }} data-id="element-856" />

          {/* Decorative border frame */}
          <div className="absolute inset-4 sm:inset-8 pointer-events-none rounded-2xl" style={{
        border: '2px solid rgba(139,105,20,0.22)',
        boxShadow: 'inset 0 0 60px rgba(139,105,20,0.06)'
      }} data-id="element-857" />

          {/* Corner ornaments */}
          {[{
        top: 14,
        left: 14
      }, {
        top: 14,
        right: 14
      }, {
        bottom: 14,
        left: 14
      }, {
        bottom: 14,
        right: 14
      }].map((pos, i) => <div key={i} className="absolute text-xl pointer-events-none select-none" style={{
        ...pos,
        color: '#8B6914',
        opacity: 0.35
      }} data-id="element-858">
              ✦
            </div>)}

          {/* Floating sparkles */}
          {[{
        top: '15%',
        left: '12%',
        size: 14,
        delay: '0s'
      }, {
        top: '20%',
        right: '10%',
        size: 11,
        delay: '0.4s'
      }, {
        top: '70%',
        left: '8%',
        size: 10,
        delay: '0.8s'
      }, {
        top: '75%',
        right: '12%',
        size: 13,
        delay: '0.2s'
      }, {
        top: '45%',
        left: '4%',
        size: 9,
        delay: '1.2s'
      }, {
        top: '40%',
        right: '5%',
        size: 10,
        delay: '0.6s'
      }].map((s, i) => <div key={i} className="absolute pointer-events-none select-none" style={{
        ...s,
        fontSize: s.size,
        color: '#C4A040',
        animation: `map-sparkle 2.5s ease-in-out infinite`,
        animationDelay: s.delay
      }} data-id="element-859">
              ✦
            </div>)}

          {/* ── MAIN CONTENT ── */}
          <div className="relative z-10 max-w-lg w-full mx-auto text-center" style={{
        animation: 'completion-meelo-entrance 900ms 200ms cubic-bezier(0.16,1,0.3,1) both'
      }} data-id="element-860">
            {/* Achievement badge */}
            <div className="inline-flex items-center gap-2 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full mb-6" style={{
          color: '#8B6914',
          background: 'rgba(139,105,20,0.12)',
          border: '1px solid rgba(139,105,20,0.28)'
        }} data-id="element-861">
              🏆 Все миссии выполнены
            </div>

            {/* Meelo — large, centered */}
            <div className="relative inline-flex flex-col items-center mb-2" data-id="element-862">
              {/* Outer glow ring */}
              <div className="absolute rounded-full pointer-events-none" style={{
            inset: -20,
            background: 'radial-gradient(circle, rgba(255,215,0,0.20) 0%, transparent 70%)',
            animation: 'node-pulse 2.5s ease-in-out infinite'
          }} data-id="element-863" />
              {/* Avatar */}
              <div className="w-28 h-28 rounded-full overflow-hidden" style={{
            background: 'rgba(255,255,255,0.95)',
            border: '4px solid rgba(255,215,0,0.55)',
            animation: 'meelo-bounce 2.2s ease-in-out infinite, golden-pulse 2.5s ease-in-out infinite',
            boxShadow: '0 8px 40px rgba(139,105,20,0.22)'
          }} data-id="element-864">
                <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-2" data-id="element-865" />
              </div>
            </div>

            {/* Meelo speech bubble */}
            <div className="mx-auto mb-6 rounded-3xl rounded-t-sm px-5 py-4 max-w-sm" style={{
          background: 'rgba(255,255,255,0.88)',
          backdropFilter: 'blur(16px)',
          border: '1.5px solid rgba(139,105,20,0.20)',
          boxShadow: '0 8px 32px rgba(139,105,20,0.12)'
        }} data-id="element-866">
              <p className="text-sm font-medium leading-relaxed" style={{
            color: '#5D3A00'
          }} data-id="element-867">
                Вы прошли путь от хаоса к порядку. Но это была только симуляция.{' '}
                <span className="font-bold" style={{
              color: '#3D2800'
            }} data-id="element-868">
                  Представьте, если это станет реальностью уже через несколько
                  дней.
                </span>
              </p>
            </div>

            {/* Stats row */}
            <div className="flex items-center justify-center gap-4 mb-7" data-id="element-869">
              {[{
            label: 'Хаос',
            value: '0%',
            color: '#16A34A',
            icon: '✓'
          }, {
            label: 'Энергия',
            value: '100%',
            color: '#7C4DFF',
            icon: '💎'
          }, {
            label: 'Прогресс',
            value: '100%',
            color: '#C4A040',
            icon: '🏆'
          }].map((stat, i) => <div key={i} className="flex flex-col items-center px-3 py-2 rounded-2xl" style={{
            background: 'rgba(255,255,255,0.65)',
            border: '1px solid rgba(139,105,20,0.18)',
            backdropFilter: 'blur(8px)'
          }} data-id="element-870">
                  <span className="text-base leading-none mb-0.5" data-id="element-871">
                    {stat.icon}
                  </span>
                  <span className="text-xs font-bold" style={{
              color: stat.color
            }} data-id="element-872">
                    {stat.value}
                  </span>
                  <span className="text-[9px] font-semibold uppercase tracking-wide" style={{
              color: '#8B6914'
            }} data-id="element-873">
                    {stat.label}
                  </span>
                </div>)}
            </div>

            {/* Divider */}
            <div className="flex items-center gap-3 mb-6 px-4" data-id="element-874">
              <div className="flex-1 h-px" style={{
            background: 'rgba(139,105,20,0.18)'
          }} data-id="element-875" />
              <span className="text-sm" style={{
            color: '#C4A040'
          }} data-id="element-876">
                ✦
              </span>
              <div className="flex-1 h-px" style={{
            background: 'rgba(139,105,20,0.18)'
          }} data-id="element-877" />
            </div>

            {/* Transition headline */}
            <h2 className="text-2xl sm:text-3xl font-bold leading-tight mb-3" style={{
          color: '#3D2800'
        }} data-id="element-878">
              Вы увидели, как это работает.
            </h2>
            <p className="text-base font-medium leading-relaxed mb-8" style={{
          color: '#8B6914'
        }} data-id="element-879">
              Теперь давайте покажем это на ваших данных.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-6" data-id="element-880">
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full font-bold text-base transition-all active:scale-95 w-full sm:w-auto" style={{
            background: 'linear-gradient(135deg, #FFD700 0%, #E8A800 100%)',
            color: '#3D1A00',
            boxShadow: '0 0 28px rgba(200,160,0,0.45), 0 4px 16px rgba(0,0,0,0.10)',
            textDecoration: 'none'
          }} data-id="element-881">
                🚀 Получить демо Meelo
              </a>
              <button onClick={() => {
            setShowCompletionOverlay(false);
            setTimeout(() => {
              document.getElementById('solutions')?.scrollIntoView({
                behavior: 'smooth'
              });
            }, 100);
          }} className="inline-flex items-center justify-center px-7 py-4 rounded-full font-medium text-base transition-all active:scale-95 w-full sm:w-auto" style={{
            border: '2px solid rgba(139,105,20,0.32)',
            color: '#5D3A00',
            background: 'rgba(255,255,255,0.50)',
            backdropFilter: 'blur(8px)'
          }} data-id="element-882">
                Посмотреть возможности
              </button>
            </div>

            {/* Dismiss hint */}
            <button onClick={() => setShowCompletionOverlay(false)} className="text-xs font-medium transition-opacity hover:opacity-70" style={{
          color: '#B8A880'
        }} data-id="element-883">
              Вернуться к карте ↩
            </button>
          </div>
        </div>}

      {/* ── MISSION MODAL ────────────────────────────────────────────── */}
      {activeMission !== null && activeBuilding && <div className="fixed inset-0 z-[100] flex items-end justify-center sm:items-center sm:p-4" data-id="element-884">
          <div className="absolute inset-0 bg-black/45 backdrop-blur-sm" onClick={() => setActiveMission(null)} data-id="element-885" />
          <div className="bg-white w-full max-w-2xl rounded-t-3xl sm:rounded-3xl max-h-[92vh] overflow-y-auto relative z-10 shadow-2xl" style={{
        animation: 'modal-slide-up 0.4s cubic-bezier(0.16,1,0.3,1) forwards'
      }} data-id="element-886">
            <div className="relative px-6 pt-6 pb-5 rounded-t-3xl overflow-hidden" style={{
          background: activeBuilding.modalGradient
        }} data-id="element-887">
              <div className="flex items-start justify-between" data-id="element-888">
                <div className="flex items-center gap-3" data-id="element-889">
                  <span className="text-3xl" data-id="element-890">{activeBuilding.icon}</span>
                  <div data-id="element-891">
                    <p className="text-xs font-semibold text-white/60 uppercase tracking-widest mb-0.5" data-id="element-892">
                      Миссия {activeMission}
                    </p>
                    <h3 className="font-bold text-white text-lg leading-tight" data-id="element-893">
                      {activeBuilding.name}
                    </h3>
                  </div>
                </div>
                <button onClick={() => setActiveMission(null)} className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition-colors mt-1" data-id="element-894">
                  <X size={16} color="white" data-id="element-895" />
                </button>
              </div>
              <div className="mt-4 flex items-start gap-2.5" data-id="element-896">
                <div className="w-7 h-7 rounded-full bg-white/20 overflow-hidden flex-shrink-0 mt-0.5" data-id="element-897">
                  <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-0.5" data-id="element-898" />
                </div>
                <p className="text-sm text-white/85 leading-relaxed italic" data-id="element-899">
                  «{activeBuilding.quote}»
                </p>
              </div>
            </div>
            <div className="p-6" data-id="element-900">
              {activeMission === 1 && <Mission1 onComplete={() => handleComplete(1)} data-id="element-901" />}
              {activeMission === 2 && <Mission2 onComplete={() => handleComplete(2)} data-id="element-902" />}
              {activeMission === 3 && <Mission3 onComplete={() => handleComplete(3)} data-id="element-903" />}
              {activeMission === 4 && <Mission4 onComplete={() => handleComplete(4)} data-id="element-904" />}
            </div>
          </div>
        </div>}

      {/* ── FINAL SECTION ────────────────────────────────────────────── */}
      <section className="py-20 lg:py-28 relative overflow-hidden transition-all duration-1000" style={{
      opacity: allDone ? 1 : 0.15,
      pointerEvents: allDone ? 'auto' : 'none',
      background: 'linear-gradient(180deg, #FFF9F0 0%, #F8F5FF 50%, white 100%)'
    }} data-id="element-905">
        {allDone && <div className="absolute top-0 left-1/2 -translate-x-1/2 pointer-events-none" style={{
        width: 600,
        height: 400
      }} data-id="element-906">
            <svg width="600" height="400" viewBox="0 0 600 400" fill="none" data-id="element-907">
              {Array.from({
            length: 12
          }).map((_, i) => <line key={i} x1="300" y1="0" x2={300 + Math.cos(i / 12 * Math.PI * 2) * 350} y2={Math.sin(i / 12 * Math.PI * 2) * 350} stroke="rgba(255,200,50,0.12)" strokeWidth="40" data-id="element-908" />)}
            </svg>
          </div>}
        <div className="max-w-xl mx-auto px-4 text-center relative z-10" data-id="element-909">
          {allDone && <div className="inline-flex items-center gap-2 bg-green-50 text-green-700 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full mb-6 border border-green-100" data-id="element-910">
              🏆 Миссия выполнена
            </div>}
          <div className="w-24 h-24 mx-auto rounded-full bg-[#EDE7F6] border-4 border-[#7C4DFF]/15 overflow-hidden mb-6 shadow-lg" style={{
          animation: 'meelo-bounce 2s ease-in-out infinite',
          boxShadow: allDone ? '0 0 0 8px rgba(124,77,255,0.08), 0 0 0 16px rgba(124,77,255,0.04)' : 'none'
        }} data-id="element-911">
            <img src="https://cdn.magicpatterns.com/uploads/k1HQQhYUAYkCqHQP8zEE8y/meelo_logo_transparent.png" alt="Meelo" className="w-full h-full object-contain p-2" data-id="element-912" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A2E] mb-3 leading-tight" data-id="element-913">
            Миссия выполнена.
            <br data-id="element-914" />
            Теперь у вас есть порядок.
          </h2>
          <p className="text-lg text-gray-500 mb-8" data-id="element-915">
            И время на главное —{' '}
            <span className="text-[#7C4DFF] font-semibold" data-id="element-916">детей</span>.
          </p>
          <div className="flex items-center justify-center gap-6 text-sm font-medium text-gray-500 mb-8" data-id="element-917">
            <span data-id="element-918">
              Хаос: <b className="text-red-400" data-id="element-919">0%</b>
            </span>
            <span className="text-gray-200" data-id="element-920">·</span>
            <span data-id="element-921">
              Энергия: <b className="text-[#7C4DFF]" data-id="element-922">92%</b>
            </span>
            <span className="text-gray-200" data-id="element-923">·</span>
            <span data-id="element-924">
              Прогресс: <b className="text-green-500" data-id="element-925">100%</b>
            </span>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3" data-id="element-926">
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-10 py-4 rounded-full bg-[#7C4DFF] text-white font-semibold text-lg hover:bg-[#651FFF] transition-all" style={{
            animation: allDone ? 'pulse-cta 2.5s ease infinite' : 'none',
            boxShadow: '0 4px 20px -2px rgba(124,77,255,0.35)'
          }} data-id="element-927">
              🚀 Хочу демо Meelo
            </a>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 rounded-full border-2 border-[#7C4DFF]/20 text-[#7C4DFF] font-medium text-lg hover:bg-[#7C4DFF]/5 transition-all" data-id="element-928">
              Запустить систему
            </a>
          </div>
        </div>
      </section>

      {/* Toast */}
      <div style={{
      position: 'fixed',
      bottom: 24,
      left: '50%',
      transform: `translateX(-50%) translateY(${toastVisible ? 0 : 80}px)`,
      opacity: toastVisible ? 1 : 0,
      transition: 'all 300ms ease',
      pointerEvents: 'none',
      zIndex: 200
    }} data-id="element-929">
        <div className="bg-[#1A1A2E] text-white text-sm font-medium px-5 py-3 rounded-2xl shadow-xl whitespace-nowrap" data-id="element-930">
          {toastMsg}
        </div>
      </div>
    </div>;
}